var frenchTranslation = {
    translations: {
        philippinePassport: "Passeport philippin",
        seamanBook: "Livret de marin",
        philSysID: "Carte d'identité PhilSys",
        iBP: "Barreau intégré des Philippines (IBP)",
        driversLicense: "Permis de conduire",
        loading: "Chargement...",
        loadingDataProvider: "Chargement du fournisseur de données...",
        tallySheetImport: {
            title: "Importations de procès-verbaux de dépouillement",
            subtitle: "Importez des fichiers de procès-verbaux de dépouillement ES&S ou CSV, prévisualisez les urnes générées et approuvez-les avant de créer des procès-verbaux de dépouillement.",
            createTitle: "Importer des procès-verbaux de dépouillement",
            detailTitle: "Importation de procès-verbal de dépouillement",
            empty: "Aucune importation de procès-verbal de dépouillement pour le moment.",
            emptyBody: "Commencez par importer un fichier ES&S Enhanced XML ou CSV canonique pour cet événement électoral.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "CSV canonique",
            },
            channel: {
                PAPER: "Papier",
                POSTAL: "Postal",
                IN_PERSON: "En personne",
            },
            table: {
                created: "Créé",
                createdBy: "Créé par",
                file: "Fichier",
                format: "Format",
                channel: "Canal",
                status: "Statut",
                labels: "Étiquettes",
                annotations: "Annotations",
                actions: "Actions",
            },
            summary: {
                imported: "Importées",
                changed: "Modifiées",
                new: "Nouvelles",
                unchanged: "Inchangées",
                conflicted: "En conflit",
                errors: "Erreurs",
            },
            status: {
                PENDING_REVIEW: "En attente de révision",
                APPROVED: "Approuvée",
                DISAPPROVED: "Désapprouvée",
                FAILED_VALIDATION: "Échec de la validation",
                CONFLICTED: "En conflit",
                NEW: "Nouvelle",
                CHANGED: "Modifiée",
                UNCHANGED: "Inchangée",
            },
            fields: {
                format: "Format",
                channel: "Canal",
                supportedFormats: "Formats pris en charge : XML, CSV",
                generatedTallySheet: "Procès-verbal de dépouillement généré",
                sourceCandidates: "IDs des candidats source",
                none: "Aucun",
            },
            actions: {
                create: "Importer des procès-verbaux de dépouillement",
                review: "Réviser",
                source: "Source",
                cancel: "Annuler",
                preview: "Prévisualiser",
                save: "Enregistrer l'importation",
                approve: "Approuver",
                disapprove: "Désapprouver",
                close: "Fermer",
                openExisting: "Ouvrir l'existante",
            },
            notifications: {
                selectFile: "Sélectionnez un fichier d'importation avant de le prévisualiser",
                duplicateSource: "Ce hash de fichier source apparaît déjà dans une importation de procès-verbal de dépouillement précédent.",
                uploadUrlError: "Impossible de créer l'URL de téléversement",
                uploadError: "Impossible de téléverser le fichier d'importation",
                previewEmpty: "La réponse de la prévisualisation était vide",
                previewError: "Impossible de prévisualiser l'importation",
                importEmpty: "La réponse de l'importation était vide",
                created: "Importation de procès-verbal de dépouillement créé",
                createError: "Impossible de créer l'importation",
                reviewEmpty: "La réponse de la révision était vide",
                conflicted: "L'importation présente des conflits de référence obsolètes",
                approved: "Importation approuvée",
                disapproved: "Importation désapprouvée",
                reviewError: "Impossible de réviser l'importation",
                sourceUrlError: "Impossible de créer l'URL de téléchargement source",
                sourceDownloadError: "Impossible de télécharger le fichier source",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} sur {{total}}",
                previous: "Précédent",
                next: "Suivant",
            },
        },
        reconciliation: {
            menuButton: "Sync. élect. ext.",
            categories: {
                VOTED_INTERNET: "A voté par Internet",
                VOTED_OTHER_CHANNEL: "A voté par un autre canal",
                DISABLED_DELETE_CALL: "Électeur désactivé",
                DELETION_REVERTED: "Suppression annulée",
                PROFILE_UPDATE: "Profil mis à jour",
                VOTER_ADDED: "Électeur ajouté",
                REENABLED: "Électeur réactivé",
                VOTED_UNMARKED: "Vote de l’électeur annulé",
                ROW_FAILURE: "Échec de ligne",
            },
            table: {
                voterId: "ID Électeur",
                field: "Champ",
                category: "Catégorie",
                currentValue: "Valeur actuelle",
                newValue: "Nouvelle valeur",
                reason: "Motif",
                rowLabel: "Ligne",
                noDifferences: "Aucune différence trouvée - les systèmes sont synchronisés.",
            },
            wizard: {
                title: "Synchronisation de réconciliation externe",
                subtitle: "Synchronisez la liste des électeurs avec le système externe",
                drop: {
                    description: "Déposez le fichier de réconciliation généré par le système externe - les deux diffs (côté externe et côté Sequent) sont calculés automatiquement et affichés dans des tableaux séparés.",
                    fileFormatLabel: "Fichier CSV",
                    uploading: "Téléversement de {{fileName}} et calcul des deux diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Séquence {{sequence}}, généré {{generatedAt}}",
                    rowFailuresWarning: "{{count}} ligne(s) n'ont pas pu être réconciliées en toute sécurité et sont exclues des deux diffs - voir les détails ci-dessous.",
                    noDifferences: "Aucune différence - les deux systèmes sont déjà synchronisés.",
                    diffOnlyDifferences: "Il s'agit d'un contrôle de convergence pour une séquence déjà appliquée. Les différences sont affichées pour suivi, mais ce cycle ne peut pas être appliqué à nouveau.",
                    externalDiffTitle: "Diff externe",
                    sequentDiffTitle: "Diff Sequent",
                    downloadExternalPatch: "Télécharger le correctif externe",
                    externalDiffCaption: "Téléchargez le correctif et remettez-le au système externe en dehors de cet outil. Une fois qu'il l'applique et produit le fichier de réconciliation suivant, cliquez sur 'Retour' et déposez ce fichier - 'Appliquer' se débloque une fois ce tableau vide.",
                    noExternalDifferences: "Aucune différence côté externe.",
                    sequentDiffCaption: "Appliquez les changements directement à Sequent en cliquant sur 'Appliquer' - aucun fichier de correctif n'est généré pour ceux-ci.",
                    noSequentDifferences: "Aucune différence côté Sequent.",
                },
                applying: {
                    inProgress: "Application des changements côté Sequent...",
                    rowFailures: "{{count}} ligne(s) ont été exclues de ce cycle et nécessitent un suivi manuel - voir les détails ci-dessous.",
                    rowFailuresTruncated: "Affichage des {{shown}} premiers échecs de ligne sur {{count}}. Corrigez la cause commune et réessayez pour voir les échecs restants.",
                    success: "Tous les changements côté Sequent ont été appliqués avec succès.",
                },
                actions: {
                    cancel: "Annuler",
                    back: "Retour",
                    apply: "Appliquer",
                    next: "Suivant",
                    startOver: "Recommencer",
                    close: "Fermer",
                },
                confirm: {
                    title: "Confirmer les changements de réconciliation",
                    categoriesNote: "Les catégories surlignées en orange ({{categories}}) affectent le statut de vote ou désactivent des électeurs.",
                    applyChanges: "Appliquer les changements",
                    continue: "Continuer",
                },
                summary: {
                    votedOtherChannel: "marque {{count}} électeur(s) comme ayant voté par un autre canal",
                    disabled: "désactive {{count}} électeur(s)",
                    reenabled: "réactive {{count}} électeur(s)",
                    votedUnmarked: "annule le vote de {{count}} électeur(s)",
                    profileUpdated: "met à jour {{count}} profil(s)",
                    voterAdded: "ajoute {{count}} électeur(s)",
                    prefix: "Ceci appliquera des changements qui {{parts}}.",
                    empty: "Il n'y a aucun changement côté Sequent à appliquer.",
                },
                notifications: {
                    envelopeLoadError: "Impossible de charger le diff de réconciliation - veuillez réessayer.",
                    generateFailed: "Impossible de calculer le diff de réconciliation - consultez le widget de tâches pour plus de détails.",
                    applyFailed: "Impossible d'appliquer les changements côté Sequent - consultez le widget de tâches pour plus de détails.",
                    uploadUrlError: "Impossible d'obtenir une URL de téléversement",
                    generateTaskError: "Impossible de démarrer la tâche de diff de réconciliation",
                    uploadError: "Impossible de téléverser le fichier de réconciliation",
                    applyTaskError: "Impossible de démarrer la tâche d'application",
                    applyError: "Impossible d'appliquer les changements de réconciliation",
                },
            },
        },
        logsScreen: {
            noPermissions: "Vous n'avez pas la permission d'accéder aux journaux.",
            title: "Journaux",
            subtitle: "Journaux généraux des bases de données principale et IAM.",
            actions: {
                csv: "Exporter en CSV",
                pdf: "Exporter en PDF",
            },
            exportdialog: {
                description: "Veuillez confirmer que vous souhaitez exécuter cette action, cela pourrait prendre un certain temps.",
            },
            column: {
                id: "ID",
                statement_kind: "Type de déclaration",
                created: "Créé",
                statement_timestamp: "Horodatage de déclaration",
                message: "Message",
                user_id: "ID utilisateur",
                username: "Nom d'Utilisateur",
                sender_pk: "Clé primaire de l'expéditeur",
                log_type: "Type de journal",
                event_type: "Type d'événement",
                description: "Description",
                version: "Version",
            },
            main: {
                title: "Journal de la Base de Données Principale",
            },
            iam: {
                title: "Journal de la Base de Données IAM",
            },
        },
        tasksScreen: {
            noPermissions: "Vous n'avez pas la permission d'accéder aux journaux.",
            title: "Exécution des tâches",
            subtitle: "Informations sur les tâches exécutées et les journaux de progression",
            taskInformation: "Informations sur la tâche",
            status: "statut : {{status}}",
            ok: "D'accord",
            column: {
                id: "Index",
                name: "Nom de la tâche",
                type: "Type",
                execution_status: "Statut",
                start_at: "Heure de début",
                end_at: "Heure de fin",
                executed_by_user: "Exécutant",
                annotations: "Annotations",
                labels: "Étiquettes",
                logs: "Journaux",
            },
            tasksExecution: {
                DELETE_TENANT: "Supprimer l’organisation",
                PUBLISH_BALLOT: "Publier le bulletin",
                VOTER_INFORMATION_LETTER: "Lettre d'information de l'électeur",
                EXPORT_ELECTION_EVENT: "Exporter l'événement électoral",
                CREATE_ELECTION_EVENT: "Créer Événement Électoral",
                IMPORT_ELECTION_EVENT: "Importer l'événement électoral",
                IMPORT_USERS: "Importer des utilisateurs",
                EDIT_USER: "Modifier l'électeur",
                IMPORT_CANDIDATES: "Importer des candidats",
                EXPORT_VOTERS: "Exporter les électeurs",
                CREATE_TRANSMISSION_PACKAGE: "Créer un paquet de transmission",
                EXPORT_BALLOT_PUBLICATION: "Exporter Publication de Bulletin",
                EXPORT_ACTIVITY_LOGS_REPORT: "Exporter le Rapport des Journaux d'Activité",
                GENERATE_REPORT: "Générer un rapport",
                GENERATE_TRANSMISSION_REPORT: "Générer un rapport de transmission",
                EXPORT_TRUSTEES: "Exporter les Autorités",
                EXPORT_APPLICATION: "Exporter les Demandes",
                EXPORT_TENANT_CONFIG: "Exporter la Configuration du Locataire",
                IMPORT_TENANT_CONFIG: "Importer la Configuration du Locataire",
                RENDER_DOCUMENT_PDF: "Générer le document PDF",
                CREATE_TENANT: "Créer un locataire",
                EXPORT_TEMPLATES: "Exporter les Modèles",
                IMPORT_TEMPLATES: "Importer les Modèles",
                DELETE_ELECTION_EVENT: "Supprimer l'événement électoral",
                DELETE_VOTERS: "Supprimer les électeurs",
                PREPARE_PUBLICATION_PREVIEW: "Préparer l'aperçu de la publication",
                EXPORT_TALLY_RESULTS_XLSX: "Exporter les résultats du dépouillement au format XLSX",
                EXPORT_CERTIFICATE_AUTHORITIES: "Exporter les autorités de certification",
                PUBLISH_RESULTS_WEBSITE: "Publier le site des résultats",
            },
            documentAccess: {
                title: "Accès au document",
                sensitivityNotice: "Informations sensibles. Ne partagez ce mot de passe qu'avec le destinataire prévu.",
                passwordLabel: "Mot de passe pour ouvrir le PDF chiffré",
                showPassword: "Afficher le mot de passe",
                copyPassword: "Copier le mot de passe",
                passwordCopied: "Mot de passe copié",
                passwordError: "Impossible de récupérer le mot de passe du PDF",
                copyError: "Impossible de copier le mot de passe",
                guidance: "Le mot de passe n'est chargé qu'après avoir choisi Afficher le mot de passe. Une fois chargé, un champ en lecture seule avec une option de copie apparaît ici.",
            },
            widget: {
                taskTitle: "Tâche: {{title}}",
                viewTask: "Voir Tâche",
                downloadDocument: "Télécharger le Fichier",
            },
            exportTasksExecution: {
                success: "L'exportation s'est terminée avec succès",
                error: "Erreur lors de l'exportation de l'exécution des tâches",
            },
        },
        areas: {
            common: {
                title: "Zones",
                subTitle: "Configuration de Zone.",
                deleteError: "Erreur lors de la suppression de la Zone",
            },
            createAreaSuccess: "Zone créée",
            updateAreaSuccess: "Zone mise à jour",
            createAreaError: "Erreur lors de la création de la zone",
            sequent_backend_area_contest: "Scrutins de la Zone",
            empty: {
                header: "Aucune Zone pour l'instant.",
                action: "Créer une Zone",
            },
            formImputs: {
                allowEarlyVoting: "Autoriser le Vote Anticipé",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Clé de Compte de Service Google Calendar",
                gapiEmail: "Email d'Authentification Google Calendar",
            },
            errors: {
                invalidGapiKey: "Format de Clé de Compte de Service Google Calendar invalide",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Liens d'Aide",
                logoUrl: "URL du Logo",
                css: "CSS Personnalisé",
            },
            errors: {
                invalidHelpLinks: "Format des Liens d'Aide invalide",
            },
        },
        electionTypeScreen: {
            noPermissions: "Vous n'avez pas la permission d'accéder à la configuration.",
            common: {
                title: "Type d'Élection",
                subtitle: "Configuration du Type d'Élection",
                onlineVoting: "Vote en Ligne",
                kioskVoting: "Vote au Kiosque",
                telephoneVoting: "Vote par Téléphone",
                settingTitle: "Configuration",
                settingSubtitle: "Paramètres généraux",
                sms: "SMS",
                mail: "Courriels",
                createNew: "Créer un Type d'Élection",
                emptyHeader: "Aucun Type d'Élection pour l'instant.",
                emptyBody: "Voulez-vous en créer un ?",
            },
            create: {
                title: "Créer un Type d'Élection",
            },
            edit: {
                title: "Éditer un Type d'Élection",
            },
            tabs: {
                votingChannels: "CANAUX DE VOTE",
                electionTypes: "TYPES D'ÉLECTION",
                templates: "MODÈLES",
                languages: "LANGUES",
                localization: "LOCALISATION",
                integrations: "INTÉGRATIONS",
                lookAndFeel: "PERSONNALISATION DE L'APPARENCE",
                schedules: "ÉVÉNEMENTS PROGRAMMÉS",
                trustees: "AUTORITÉS",
                BackupRestore: "SAUVEGARDE / RESTAURATION",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Pas encore de fiduciaires.",
                createNew: "Créer un fiduciaire",
                title: "Fiduciaire",
                subtitle: "Configuration du fiduciaire",
                emptyBody: "Voulez-vous en créer un?",
            },
            create: {
                title: "Créer un fiduciaire",
            },
            edit: {
                title: "Modifier le fiduciaire",
            },
        },
        scheduleScreen: {
            noPermissions: "Vous n'avez pas la permission d'accéder à la configuration.",
            createScheduleSuccess: "Date créée",
            createScheduleError: "Erreur lors de la création de la date",
            deleteScheduleSuccess: "Date supprimée",
            deleteScheduleError: "Erreur lors de la suppression de la date",
            common: {
                title: "Programmé",
                subtitle: "Configuration des dates",
                createNew: "Créer une date",
                emptyHeader: "Aucune date pour l'instant.",
                emptyBody: "Voulez-vous en créer une ?",
            },
            create: {
                title: "Créer une date",
                selectSchedule: "Sélectionnez un horaire de la liste prédéfinie ou écrivez-en un personnalisé",
            },
            edit: {
                title: "Éditer une date",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Verrouillage du système pour la finalisation de la configuration de vote par Internet",
                START_PRE_REGISTRATION_OVCS: "Début de la pré-inscription pour OVCS",
                END_PRE_REGISTRATION_OVCS: "Fin de la pré-inscription pour OVCS",
                START_TEST_VOTING_PERIOD: "Début de la période de vote de test",
                END_TEST_VOTING_PERIOD: "Fin de la période de vote de test",
                START_INTERNET_VOTING_PERIOD: "Début de la période de vote par Internet",
                END_INTERNET_VOTING_PERIOD: "Fin de la période de vote par Internet",
                LAB_TEST: "Test de laboratoire",
                FIELD_TEST: "Test sur le terrain",
                MOCK_ELECTIONS: "Élections simulées",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Votes par jour",
            votesOverTime: "Votes au fil du temps",
            timeResolution: "Résolution temporelle",
            timeRange: "Plage de temps",
            minute: "Minute",
            hour: "Heure",
            day: "Jour",
            votersByChannels: "Votants par canaux",
            voterLoginURL: "URL de connexion des électeurs",
            voterEnrollURL: "URL d'inscription des électeurs",
            voterEnrollKioskURL: "Kiosk URL d'inscription des électeurs",
            ipAddress: {
                emptyState: "Pas encore de votes.",
                title: "Adresses IP",
                ip: "IP",
                country: "Pays",
                VoteCount: "Nombre de votes",
                ElectionName: "Nom de l'élection",
                VotersId: "Identifiants des votants",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Configuration de l'Événement Électoral.",
                showMore: "Afficher plus",
                showLess: "Afficher moins",
                adminPortal: "Portail d'administration",
                allowPublishAfterLockdown: "N'autoriser la publication de l'événement électoral qu'après le verrouillage",
                reset: "Réinitialiser le filtre personnalisé",
            },
            edit: {
                general: "Général",
                dates: "Dates",
                customUrls: "Préfixer les URL personnalisées",
                votingPeriod: "Période de vote",
                language: "Langues",
                languageAndRegion: "Langue et région",
                allowed: "Canaux de Vote Permis",
                materials: "Matériaux de Support",
                ballotDesign: "Design du Bulletin",
                templates: "Modèles",
                reorder: "Réorganiser les élections",
                advancedConfigurations: "Voting Portal Countdown Policy",
                importCandidates: "Importer des Candidats",
                custom_filters: "Filtres personnalisés",
                voter_authentication: "Authentification des électeurs",
                realm_attributes: "Attributs du realm Keycloak",
                realm_attributes_load_error: "Erreur lors du chargement des attributs du realm Keycloak",
                realm_attributes_update_error: "Erreur lors de la mise à jour des attributs du realm Keycloak",
                realm_attributes_not_loaded: "Les attributs du realm Keycloak n'ont pas été chargés ; les modifications n'ont pas été enregistrées",
                password_policy: "Politique de mots de passe",
                password_policy_load_error: "Erreur lors du chargement de la politique de mots de passe Keycloak",
                password_policy_update_error: "Erreur lors de la mise à jour de la politique de mots de passe Keycloak",
                password_policy_not_loaded: "La politique de mots de passe Keycloak n'a pas été chargée ; les modifications n'ont pas été enregistrées",
            },
            customUrls: {
                login: "Connexion",
                enrollment: "Inscription",
            },
            localization: {
                emptyHeader: "Aucune langue n'a été définie pour l'événement",
                selectLanguage: "Sélectionnez la langue",
                notify: {
                    success: "Localisation mise à jour avec succès",
                    error: "Échec de la mise à jour de la localisation",
                    duplicateKey: "Un remplacement avec cette clé et cette portée existe déjà.",
                    invalidDateTimeFormat: "Format de date/heure non valide. Utilisez les jetons yyyy, MM, dd, HH, mm, ss (ex. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Localisation",
                    subTitle: "Configuration de la localisation",
                },
                labels: {
                    key: "Clé",
                    scope: "Portée du portail",
                    value: "Valeur",
                },
                scopes: {
                    legacy: "Hérité ({{portal}})",
                    global: "Global",
                    votingPortal: "Portail de vote",
                    ballotVerifier: "Vérificateur de bulletins",
                    resultsPortal: "Portail des résultats",
                    adminPortal: "Portail d'administration",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Longueur minimale",
                    maximumLength: "Longueur maximale",
                    includeUppercase: "Inclure des lettres majuscules",
                    includeLowercase: "Inclure des lettres minuscules",
                    includeDigits: "Inclure des chiffres",
                    includeSpecialCharacters: "Inclure des caractères spéciaux",
                    help: {
                        minimumLength: "Le nombre minimal de caractères requis pour le mot de passe.",
                        maximumLength: "Le nombre maximal de caractères autorisés dans le mot de passe.",
                        includeUppercase: "Le mot de passe doit contenir au moins une lettre majuscule.",
                        includeLowercase: "Le mot de passe doit contenir au moins une lettre minuscule.",
                        includeDigits: "Le mot de passe doit contenir au moins un chiffre.",
                        includeSpecialCharacters: "Le mot de passe doit contenir au moins un caractère spécial.",
                    },
                    notConfigured: "Aucune politique de mot de passe n'est configurée. L'enregistrement appliquera les valeurs par défaut ci-dessous.",
                    errors: {
                        lengthRange: "Les longueurs du mot de passe doivent être des nombres entiers compris entre 1 et 256.",
                        minimumExceedsMaximum: "La longueur minimale ne peut pas dépasser la longueur maximale.",
                        characterClassRequired: "Sélectionnez au moins une classe de caractères pour le mot de passe.",
                    },
                },
                name: "Nom",
                alias: "Alias",
                description: "Description",
                startDateTime: "Date et heure de début",
                endDateTime: "Date et heure de fin",
                language: "Langue",
                votingChannels: "Canaux de Vote",
                materialActivated: "Matériaux de Support activés",
                supportMaterialsPolicy: {
                    label: "Politique des Matériaux de Support",
                    helperText: "L'option Obligatoire pour Voter exige que les électeurs ouvrent chaque Matériau de Support et confirment qu'ils l'ont lu avant de pouvoir voter.",
                    options: {
                        off: "Désactivé",
                        optional: "Facultatif",
                        mandatory_for_voting: "Obligatoire pour Voter",
                    },
                },
                materialTitle: "Titre",
                materialSubTitle: "Sous-titre",
                logoUrl: "URL du Logo",
                userVerification: "Vous pouvez introduire un modèle personnalisé qui sera utilisé pour vérifier manuellement les électeurs",
                redirectFinishUrl: "URL de redirection à la fin",
                kioskRedirectFinishUrl: "URL de redirection à la fin du vote en kiosque",
                css: "CSS personnalisé",
                skipElectionList: "Passer l'écran pour choisir l'élection",
                showUserProfile: "Afficher le profil utilisateur",
                showCastVoteLogs: {
                    policyLabel: "Afficher les logs de vote",
                    options: {
                        "show-logs-tab": "Afficher l'onglet des logs de vote",
                        "hide-logs-tab": "Ne pas afficher l'onglet des logs de vote",
                    },
                },
                lockdownState: {
                    policyLabel: "État de Confinement",
                    options: {
                        "locked-down": "Confiné",
                        "not-locked-down": "Non Confiné",
                    },
                },
                decodedBallots: {
                    policyLabel: "Inclure les bulletins décodés dans la base de données de résultats",
                    options: { "included": "Inclure", "not-included": "Ne pas inclure" },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Scrutin unique",
                        "multiple-contests": "Plusieurs scrutins",
                    },
                    policyLabel: "Politique de chiffrement de scrutin",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Format de date et d'heure du portail de vote",
                    helperText: "S'applique à tout l'événement. Pour le remplacer par langue, ajoutez la clé \"votingPortalDateTimeFormat\" dans l'onglet Localisation avec les jetons yyyy, MM, dd, HH, mm, ss (ex. dd/MM/yyyy HH:mm). Consultez la documentation pour plus de détails.",
                    options: {
                        "legacy-gb-24h": "GB hérité 24 h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO local (yyyy-MM-dd HH:mm)",
                        "us-12h": "États-Unis 12 h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (date moyenne, heure courte)",
                        "date-only": "Date Only (sans heure)",
                        "custom": "Format personnalisé",
                    },
                    customFormat: {
                        label: "Format de date et d'heure personnalisé",
                        helperText: "Utilisez les jetons yyyy, MM, dd, HH, mm, ss (ex. dd/MM/yyyy HH:mm). Tout autre caractère est affiché tel quel.",
                        invalid: "Format invalide. Utilisez au moins un des jetons yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Pas de compte à rebours",
                    COUNTDOWN: "Compte à rebours",
                    COUNTDOWN_WITH_ALERT: "Compte à rebours avec alerte",
                    sectionTitle: "Portail de vote",
                    policyLabel: "Politique de compte à rebours du portail de vote",
                    coundownSecondsLabel: "temps en secondes avant expiration pour afficher le compte à rebours",
                    alertSecondsLabel: "temps en secondes avant expiration pour afficher l'alerte de déconnexion",
                },
                voterSigningPolicy: {
                    "policyLabel": "Politique de Signature des Électeurs",
                    "no-signature": "Sans signature",
                    "with-signature": "Avec signature",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Politique de certificat numérique du votant",
                    enabled: "Activé",
                    disabled: "Désactivé",
                },
                enrollment: {
                    policyLabel: "Inscription",
                    options: {
                        enabled: "Activé",
                        disabled: "Désactivé",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Activé",
                        disabled: "Désactivé",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Politique des cérémonies de clés/décompte",
                    options: {
                        "automated-ceremonies": "Autoriser les cérémonies automatiques",
                        "manual-ceremonies": "Cérémonies manuelles",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Recomptage automatique après approbation de l'import",
                    options: {
                        enabled: "Activé",
                        disabled: "Désactivé",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Politique de Vote Pondéré",
                    options: {
                        "areas-weighted-voting": "Vote Pondéré par Zones",
                        "voters-weighted-voting": "Vote Pondéré par Électeurs",
                        "disabled-weighted-voting": "Vote Pondéré Désactivé",
                    },
                    noDelegated: "Le Vote Pondéré par Électeurs ne peut pas être combiné avec le Vote Délégué",
                    noDecodedBallots: "Le Vote Pondéré par Électeurs ne peut pas être combiné avec l'inclusion des bulletins déchiffrés dans les résultats",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Politique de vote délégué",
                    options: {
                        enabled: "Activé",
                        disabled: "Désactivé",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Politique de détection de la langue",
                    options: {
                        "browser-detect": "Détection par le navigateur",
                        "force-default": "Forcer par défaut",
                    },
                },
                numberFormatPolicy: {
                    policyLabel: "Politique de format des nombres",
                    helperText: "S'applique aux nombres des résultats, des tableaux de bord et des rapports.",
                    unknownPolicy: "Format inconnu '{{policy}}', affiché comme {{sample}}",
                },
            },
            error: {
                endDate: "La date de fin doit être postérieure à la date de début",
                noResult: "Pas encore d'Événement Électoral",
                startDate: "La date de début doit être dans le futur",
                endDateInvalid: "La date de fin doit être dans le futur",
            },
            voters: {
                title: "Électeurs",
            },
            createElectionEventSuccess: "Événement Électoral créé",
            createElectionEventError: "Erreur lors de la création de l'Événement Électoral",
            ivr: {
                tabs: {
                    config: "Configuration",
                    blacklist: "Liste de blocage",
                    prompts: "Messages vocaux",
                    emulator: "Émulateur",
                },
                common: {
                    saveSuccess: "Enregistré avec succès",
                    saveError: "Échec de l’enregistrement",
                    deleteSuccess: "Supprimé avec succès",
                    deleteError: "Échec de la suppression",
                },
                config: {
                    configuredPhone: "Numéro de téléphone configuré",
                    infoMsg: "Configurez le flux du SVI et ses propriétés ci-dessous. Pour plus de détails, veuillez contacter Sequent.",
                },
                prompts: {
                    emptyMsg: "Aucun message n’a encore été créé",
                    infoMsg: "Configurez les messages utilisés par le SVI. Les messages d’annonce sont obligatoires, et les messages système peuvent être remplacés pour les langues souhaitées. SSML est pris en charge, y compris pour mélanger les langues.",
                    editorTitle: "Message",
                    editorSubtitle: "Configuration du message",
                },
                blacklist: {
                    columns: {
                        phone: "Numéro de téléphone",
                        reason: "Motif",
                        createdAt: "Créé le",
                        createdBy: "Créé par",
                        createdBefore: "Créé avant",
                        createdAfter: "Créé après",
                    },
                    emptyMsg: "Il n’y a aucune entrée dans la liste de blocage",
                    infoMsg: "Configurez la liste de blocage du SVI. Les appels provenant de ces numéros seront automatiquement déconnectés par le système.",
                    noFilterMatch: "Aucune entrée ne correspond aux filtres indiqués",
                    phoneRequired: "Le numéro de téléphone est obligatoire",
                },
                emulator: {
                    infoMsg: "Sélectionnez une zone et les élections souhaitées pour tester la session IVR.",
                    apiStatus: {
                        unavailable: "Le système d'émulation n'est pas disponible dans votre environnement",
                        loading: "Chargement du système d'émulation",
                        error: "Erreur lors du chargement du système d'émulation",
                    },
                    hints: {
                        title: "Conseils",
                        publishRequired: "Toute modification apportée aux élections, aux scrutins ou aux candidats doit d'abord être publiée pour être disponible. Seuls les styles de bulletin publiés les plus récents correspondant à la zone seront utilisés dans l'émulateur.",
                        eventChangesImmediate: "Les modifications apportées à l'événement électoral, telles que la configuration IVR ou la personnalisation des messages, sont disponibles immédiatement après le redémarrage de la session de l'émulateur.",
                        credentials: 'L\'identifiant d\'électeur et le code PIN valides sont "123" et "123".',
                    },
                    sendDtmf: "Envoyer une entrée DTMF",
                    sendTimeout: "Envoyer l'expiration du délai",
                    disconnected: "Déconnecté",
                    startSession: "Démarrer une nouvelle session",
                    endSession: "Terminer la session",
                    noStylesFound: "Aucun style de bulletin publié ne correspond à vos sélections",
                    inputPlaceholder: "Saisissez votre entrée (nombre maximal de chiffres={{maxDigits}}, entrées valides={{validInputs}}, délai d'expiration={{timeout}} s)",
                    blacklistCaller: "Bloquer l'appelant",
                    elections: "Élections",
                    area: "Zone",
                },
            },
            stats: {
                elegibleVoters: "Électeurs",
                voters: "Votants",
                elections: "Élections",
                contests: "Scrutins",
                areas: "Zones",
                sentEmails: "Emails Envoyés",
                sentSMS: "SMS Envoyés",
                calendar: {
                    title: "Calendrier",
                    scheduled: "Programmé",
                },
            },
            keys: {
                createNew: "Créer une Cérémonie de Clés",
                emptyHeader: "Aucune Cérémonie de Clés pour l'instant.",
                statusLabel: "État",
                waitingKeys: "En attente de la Génération de Clés..",
                started: "Commencée à",
                actions: {
                    participate: "Participer à la cérémonie des clés",
                    view: "Voir la cérémonie des clés",
                },
                breadCrumbs: {
                    configure: "Configurer",
                    ceremony: "Cérémonie",
                    created: "Terminé",
                    start: "Début",
                    status: "État",
                    download: "Télécharger",
                    check: "Vérifier",
                    success: "Finalisé",
                },
                notify: {
                    participateNow: "Vous avez été invité à participer à une Cérémonie de Clés. Veuillez <1>cliquer ci-dessous sur l'action de clé de la cérémonie</1> pour participer.",
                },
            },
            tabs: {
                dashboard: "Tableau de Bord",
                monitoring: "Surveillance",
                data: "Données",
                ivr: "IVR",
                localization: "Localisation",
                voters: "Électeurs",
                areas: "Zones",
                keys: "Clés",
                tally: "Comptage",
                tallySheetImports: "Importation des procès-verbaux de dépouillement",
                publish: "Publier",
                logs: "Journaux",
                tasks: "Tâches",
                events: "Événement Planifié",
                notifications: "Notifications",
                reports: "Rapport",
                approvals: "Approbations",
                cas: "Certificats",
            },
            tally: {
                emptyHeader: "Aucun Comptage pour l'instant.",
                title: "Comptage de l'Événement Électoral",
                elections: "Élections",
                electionNumber: "Nombre d'Élections",
                trustees: "Autorités",
                status: "État",
                permissionLabels: "Étiquettes d’Autorisation",
                tallyType: {
                    label: "Type de Décompte",
                    ELECTORAL_RESULTS: "Résultats Électoraux",
                    INITIALIZATION_REPORT: "Résultats de l'Initialisation",
                },
                create: {
                    title: "Créer un Comptage",
                    subtitle: "Créer un nouveau Comptage pour cet Événement Électoral",
                    createTallyButton: "Lancer la Cérémonie de Comptage",
                    createInitializationReportButton: "Créer un Rapport d'Initialisation",
                    error: {
                        create: "Erreur lors de la création du Comptage",
                    },
                    success: "Comptage créé",
                },
                logs: {
                    noLogs: "Aucun journal disponible",
                },
                notify: {
                    noKeysTally: "La Cérémonie de Comptage ne peut pas commencer tant que la Cérémonie de Fideicomisarios n'a pas été réalisée avec succès.",
                    noPublication: "La Cérémonie de Dépouillement ne peut pas commencer tant que vous n'avez pas créé une publication dans l'onglet Publier.",
                    participateNow: "Vous avez été invité à participer à une Cérémonie de Comptage. Veuillez <1>cliquer ci-dessous sur l'action de clé de la cérémonie</1> pour participer.",
                    startDisabled: "Vous ne pouvez pas continuer la cérémonie car aucune élection n'est sélectionnée ou les élections ne sont pas publiées.",
                    ceremonyDisabled: "Vous ne pouvez pas continuer la cérémonie car la session de dépouillement n'est pas connectée ou le début de la cérémonie n'est pas autorisé.",
                },
            },
            importAreas: {
                title: "Importer des Zones",
                subtitle: "Importer des données de zones",
                areaParagraph: "Importer des zones en utilisant un fichier tableur au format Valeurs Séparées par des Virgules (CSV).",
                importSuccess: "Zones Importées avec Succès",
                importError: "Erreur lors de l'importation des Zones",
                upsert: "Insérer ou mettre à jour les zones",
            },
            import: {
                eetitle: "Importer un Événement Électoral",
                eesubtitle: "Importer des données de l'Événement Électoral",
                title: "Importer des électeurs",
                subtitle: "Importer des électeurs à l'Événement Électoral",
                voters: "Électeurs",
                votersParagraph: "Importez des électeurs en utilisant une feuille de calcul au format Valeurs Séparées par Comma (CSV). Téléchargez un exemple de fichier d'importation CSV ici.",
                electionEventParagraph: "Importez des Événements Électoraux en utilisant un fichier JSON.",
                elections: "Élections",
                areas: "Zones",
                sha: "Vérification de l'Intégrité (SHA 256)",
                cancel: "Annuler",
                import: "Importer",
                fileUploadSuccess: "Fichier chargé sur le serveur - mais pas encore importé",
                fileUploadError: "Erreur lors du chargement du fichier",
                importVotersSuccess: "Importation des Électeurs lancée en arrière-plan avec succès.",
                importVotersError: "Erreur lors de l'Importation des Électeurs.",
                importElectionEventSuccess: "Événement électoral importé avec succès",
                importElectionEventError: "Erreur lors de l'importation de l'événement électoral",
                shaDialog: {
                    ok: "Oui, Importer Sans Vérification de l'Intégrité",
                    cancel: "Retour",
                    title: "Importer Sans Vérification de l'Intégrité ?",
                    description: "Vous n'avez pas entré le champ de Vérification de l'Intégrité (SHA-256). Confirmez que vous importez le fichier correct et que vous souhaitez l'importer.",
                },
                passwordDialog: {
                    title: "Mot de passe de déchiffrement",
                    description: "Entrez le mot de passe pour déchiffrer le fichier",
                    label: "Mot de passe",
                    copyPassword: "Copier le Mot de Passe",
                    ok: "OK",
                },
            },
            export: {
                title: "Exporter l'Événement Électoral",
                subtitle: "L'exportation peut être une opération longue. Êtes-vous sûr de vouloir exporter les enregistrements ?",
                encryptWithPassword: "Chiffrer avec Mot de Passe",
                passwordForcedNote: "L'archive sera protégée par mot de passe de toute façon : les rapports, les demandes et les données du tableau d'affichage sont toujours chiffrés. Cochez la case pour inclure aussi les champs secrets des électeurs déchiffrés.",
                includeVoters: "Inclure les Électeurs",
                activityLogs: "Journaux d'Activité",
                bulletinBoard: "Tableau d'Affichage",
                publications: "Publications",
                s3Files: "Fichiers S3",
                scheduledEvents: "Événements Planifiés",
                exportSuccess: "Événement Électoral exporté avec succès",
                exportError: "Erreur lors de l'exportation de l'Événement Électoral",
                passwordTitle: "Mot de Passe",
                passwordDescription: "Mot de passe pour déchiffrer le fichier :",
                copiedSuccess: "Mot de passe copié dans le presse-papiers",
                copiedError: "Erreur lors de la copie",
                reports: "Rapports",
                applications: "Applications",
                tally: "Décompte",
                certificates: "Certificats",
            },
            taskNotification: "{{action}} a commencé. Vous pouvez voir son statut dans le tableau d'Exécution des Tâches.",
        },
        electionScreen: {
            common: {
                title: "Élection",
                subtitle: "Configuration de l'élection.",
                fileLoaded: "Fichier chargé",
                noPermission: "Vous n'avez pas la permission d'accéder à cette élection.",
            },
            edit: {
                general: "Général",
                dates: "Dates",
                votingPeriod: "Période de vote",
                language: "Langue",
                allowed: "Canaux de Vote Permis",
                default: "Par défaut",
                defaultLang: "Langue par défaut",
                receipts: "Reçus",
                image: "Image",
                advanced: "Configuration Avancée",
                numAllowedVotes: "Nombre de votes permis",
                reorder: "Réorganiser les scrutins",
                castVoteConfirm: "Modal de Confirmation de Vote",
                gracePeriodPolicy: "Politique de période de grâce",
                allowTallyPolicy: "Autoriser le décompte",
                permissionLabel: "Étiquette de permission",
                custom_filters: "Filtres personnalisés",
            },
            field: {
                name: "Nom",
                language: "Langue",
                votingChannels: "Canaux de Vote",
                startDateTime: "Date et heure de début",
                endDateTime: "Date et heure de fin",
                startDateTimeWithTimezone: "Date et heure de début ({{timezone}})",
                endDateTimeWithTimezone: "Date et heure de fin ({{timezone}})",
                scheduledOpening: "Ouverture Prévue",
                scheduledClosing: "Fermeture Prévue",
                alias: "Alias",
                description: "Description",
                securityConfirmationHtml: "Confirmation de sécurité HTML",
                ivrPrompt: "Message IVR",
                externalId: "ID externe",
            },
            securityConfirmationPolicy: {
                label: "Politique de la case à cocher de confirmation de sécurité",
                none: "Aucun",
                mandatory: "Obligatoire",
            },
            error: {
                endDate: "La date de fin doit être postérieure à la date de début",
                fileError: "Erreur lors du chargement du fichier",
                fileLoaded: "Fichier chargé",
                startDate: "La date de début doit être dans le futur",
                endDateInvalid: "La date de fin doit être dans le futur",
            },
            createElectionEventSuccess: "Élection créée",
            createElectionEventError: "Erreur lors de la création de l'élection",
            tabs: {
                dashboard: "Tableau de Bord",
                monitoring: "Surveillance",
                data: "Données",
                voters: "Électeurs",
                publish: "Publier",
                logs: "Journaux",
                approvals: "Approbations",
                tallySheets: "Feuilles de Comptage",
            },
            gracePeriodPolicy: {
                "label": "Politique de période de grâce",
                "no-grace-period": "Pas de période de grâce",
                "grace-period-without-alert": "Période de grâce sans alerte",
                "gracePeriodSecs": "Période de grâce en secondes",
            },
            allowTallyPolicy: {
                "allowed": "Autorisé",
                "disallowed": "Non autorisé",
                "requires-voting-period-end": "Nécessite la fin de la période de vote",
            },
            initializeReportPolicy: {
                "label": "Initialiser la Politique de Rapport",
                "not-required": "Non Requis",
                "required": "Requis",
            },
            castVoteGoldLevelPolicy: {
                label: "Politique d'authentification de niveau or",
                options: {
                    "gold-level": "Authentification de niveau or",
                    "no-gold-level": "Pas d'authentification de niveau or",
                },
            },
            slates: {
                enable: {
                    label: "Activer les listes",
                    helper: "Lorsque cette option est activée, les électeurs peuvent choisir une liste nommée et modifier n'importe quel scrutin, y compris avec des candidats indépendants.",
                },
                disable: {
                    confirm: "Désactiver les listes",
                    message_one: "Cette élection a {{count}} liste. Désactiver les listes la supprimera à l'enregistrement.",
                    message_many: "Cette élection a {{count}} listes. Désactiver les listes les supprimera à l'enregistrement.",
                    message_other: "Cette élection a {{count}} listes. Désactiver les listes les supprimera à l'enregistrement.",
                },
                mobileCandidateLists: {
                    label: "Listes de candidats sur mobile",
                    helper: "État initial de la liste de candidats de chaque liste sur mobile : Repliées ou Dépliées. Les électeurs peuvent toujours ouvrir ou fermer chaque liste. Sur ordinateur, tous les candidats sont toujours affichés.",
                    options: {
                        collapsed: "Repliées",
                        expanded: "Dépliées",
                    },
                },
            },
            startScreenTitlePolicy: {
                label: "Politique de titre de l'écran d'accueil",
                options: {
                    "election": "Titre de l'élection",
                    "election-event": "Titre de l'événement électoral",
                },
            },
            consolidatedReportPolicy: {
                label: "Politique de rapport consolidé",
                options: {
                    "generate": "Générer",
                    "do-not-generate": "Ne pas générer",
                },
            },
            declineToVotePolicy: {
                label: "Politique d’abstention de vote",
                options: {
                    enabled: "Activé",
                    disabled: "Désactivé",
                },
            },
            blankBallotsPolicy: {
                label: "Politique des bulletins blancs",
                options: {
                    enabled: "Activé",
                    disabled: "Désactivé",
                },
            },
            votingScreenBackPolicy: {
                label: "Politique du bouton Retour de l’écran de vote",
                options: {
                    "election-selection-screen": "Aller à l’écran de sélection des élections",
                    "start-screen": "Aller à l’écran d’accueil de l’élection",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Locataires",
            },
            new: {
                subtitle: "Créer un nouveau locataire",
            },
            createSuccess: "Locataire créé",
            createError: "Erreur lors de la création du locataire",
        },
        usersAndRolesScreen: {
            noPermissions: "Vous n'avez pas la permission d'accéder aux utilisateurs ou rôles.",
            common: {
                title: "Utilisateurs et Rôles",
                subtitle: "Configuration générale",
                mobileNumber: "Mobile",
            },
            editPassword: {
                passwordPolicyViolation: "Le mot de passe ne respecte pas la Politique de mot de passe de cet événement électoral. Consultez la politique dans Données de l'événement électoral et saisissez un mot de passe conforme.",
                passwordPolicyRules: {
                    minimumLength: "La longueur minimale du mot de passe est de {{count}}.",
                    maximumLength: "La longueur maximale du mot de passe est de {{count}}.",
                    uppercase: "Caractères majuscules requis : {{count}}.",
                    lowercase: "Caractères minuscules requis : {{count}}.",
                    digits: "Chiffres requis : {{count}}.",
                    specialCharacters: "Caractères spéciaux requis : {{count}}.",
                },
                label: "Changer le mot de passe",
                temporatyLabel: "Temporaire",
                temporatyInfo: "Si activé, l'utilisateur devra changer le mot de passe lors de la prochaine connexion.",
            },
            users: {
                title: "Utilisateurs",
                subtitle: "Voir et éditer les données de l'utilisateur",
                review: {
                    title: "Vérifier les modifications",
                    subtitle: "Confirmez ces mises à jour avant de les soumettre.",
                    confirm: "Confirmer les modifications",
                    noChanges: "Aucune modification à vérifier",
                    field: "Champ",
                    currentValue: "Valeur actuelle",
                    newValue: "Nouvelle valeur",
                },
                edit: {
                    title: "Informations de l'Utilisateur",
                    subtitle: "Voir et éditer l'Utilisateur",
                },
                create: {
                    title: "Utilisateur",
                    subtitle: "Créer utilisateur",
                },
                fields: {
                    "has_voted": "A voté",
                    "support_materials_viewed": "Matériaux de Support consultés",
                    "vote-weight": "Poids du vote",
                    "voted-channel": "Canal de vote",
                    "disable-comment": "Commentaire de désactivation",
                    "username": "Nom d'Utilisateur",
                    "first_name": "Prénom",
                    "last_name": "Nom",
                    "email": "Email",
                    "enabled": "Activé",
                    "emailVerified": "Email Vérifié",
                    "groups": "Groupes",
                    "attributes": "Attributs",
                    "area": "Zone",
                    "password": "Mot de passe",
                    "savePassword": "Sauvegarder le mot de passe",
                    "repeatPassword": "Répéter le Mot de Passe",
                    "passwordMismatch": "Les mots de passe doivent correspondre",
                    "passwordLengthValidate": "Le mot de passe doit avoir au moins 8 caractères",
                    "passwordUppercaseValidate": "Le mot de passe doit contenir au moins une lettre majuscule",
                    "passwordLowercaseValidate": "Le mot de passe doit contenir au moins une lettre minuscule",
                    "passwordDigitValidate": "Le mot de passe doit contenir au moins un chiffre",
                    "passwordSpecialCharValidate": "Le mot de passe doit contenir au moins un caractère spécial",
                    "trustee": "Agir en tant que fiduciaire",
                    "permissionLabel": "Libellé d'autorisation",
                    "authorized-election-ids": "Élections",
                },
                delete: {
                    body: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
                    bulkBody: "Êtes-vous sûr de vouloir supprimer les utilisateurs sélectionnés ?",
                    bulkBodySelected: "Supprimer les {{count}} utilisateurs sélectionnés ? Cette action est irréversible.",
                    bulkBodyChoose: "{{count}} utilisateurs sont sélectionnés. Vous pouvez plutôt supprimer tous les utilisateurs correspondant aux filtres actuels, qui peuvent être plus nombreux. Cette action est irréversible.",
                    okSelected: "Supprimer les {{count}} sélectionnés",
                    okAllMatching: "Supprimer tous les résultats correspondants",
                },
                notifications: {
                    exportError: "Erreur lors de l'exportation des utilisateurs",
                    deleteError: "Erreur lors de la suppression de l'utilisateur",
                    deleteSuccess: "Utilisateur supprimé",
                    multipleDeleteSuccess: "Utilisateurs supprimés",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Lettre d'information de l'électeur",
                    generate: "Générer",
                    confirmation: "Générer une Lettre d'information pour cet électeur ? Un nouveau mot de passe sera attribué et inclus dans un PDF chiffré.",
                    generationStarted: "La génération de la Lettre d'information a commencé",
                    generationError: "La Lettre d'information n'a pas pu être générée",
                    policyNotConfigured: "La Politique de mot de passe n'est pas configurée. Configurez-la dans Données de l'événement électoral avant de générer une lettre.",
                    policyMinimumLengthMissing: "La Politique de mot de passe doit inclure une longueur minimale avant de générer une lettre.",
                    policyCharacterClassMissing: "La Politique de mot de passe doit inclure au moins une classe de caractères avant de générer une lettre.",
                },
                title: "Électeurs",
                subtitle: "Voir et éditer les données de l'électeur",
                secretAttribute: {
                    storedPlaceholder: "Valeur chiffrée enregistrée",
                    reveal: "Afficher",
                    hide: "Masquer",
                    revealError: "Le champ chiffré de l'électeur n'a pas pu être affiché",
                    includeInExport: "Inclure les champs secrets déchiffrés de l'électeur",
                    exportWarning: "Exportation sensible : le CSV téléchargé contiendra ces champs en texte clair.",
                    clear: "Effacer",
                    add: "Ajouter une valeur",
                    remove: "Supprimer la valeur",
                },
                review: {
                    title: "Vérifier les modifications",
                    subtitle: "Confirmez ces mises à jour avant de les soumettre.",
                    confirm: "Confirmer les modifications",
                    noChanges: "Aucune modification à vérifier",
                    field: "Champ",
                    currentValue: "Valeur actuelle",
                    newValue: "Nouvelle valeur",
                },
                logs: {
                    label: "Journaux de l'utilisateur",
                },
                emptyHeader: "Aucun électeur pour l'instant.",
                askCreate: "Voulez-vous en créer un ?",
                create: {
                    title: "Électeur",
                    subtitle: "Créer électeur",
                },
                manualVerification: {
                    label: "Vérifier manuellement",
                    verify: "Vérifier manuellement l'électeur",
                    body: "Vérifiez manuellement cet électeur. Vous obtiendrez un PDF avec un lien de code QR qui permettra à l'électeur de se connecter en omettant le KYC en ligne.",
                    noEmailOrPhone: "Cet électeur ne peut pas être vérifié manuellement car il n'a pas d'adresse e-mail ou de numéro de téléphone attribué",
                },
                errors: {
                    editError: "Erreur lors de l'édition de l'électeur",
                    editErrorReason: "Erreur lors de l'édition de l'électeur : {{reason}}",
                    editSuccess: "Électeur édité",
                    createError: "Erreur lors de la création de l'électeur",
                    createErrorReason: "Erreur lors de la création de l'électeur : {{reason}}",
                    createSuccess: "Électeur créé",
                    attribute: {
                        invalidNamed: '"{{field}}" a été refusé : {{constraint}}',
                        fieldsToCorrect: "Certains champs doivent être corrigés avant d'enregistrer",
                        hintBetween: "Entre {{min}} et {{max}} caractères",
                        hintMin: "Au moins {{min}} caractères",
                        hintMax: "Au maximum {{max}} caractères",
                        andMore: "et {{count}} de plus",
                        invalidLength: '"{{field}}" doit contenir entre {{min}} et {{max}} caractères',
                        tooShort: '"{{field}}" doit contenir au moins {{min}} caractères',
                        tooLong: '"{{field}}" doit contenir au maximum {{max}} caractères',
                        required: '"{{field}}" est obligatoire',
                        invalidEmail: '"{{field}}" doit être une adresse e-mail valide',
                        invalidFormat: '"{{field}}" n\'a pas le format attendu',
                        invalid: '"{{field}}" a une valeur non valide',
                    },
                    createPasswordError: "Électeur créé, mais son mot de passe n'a pas pu être défini",
                    createPasswordErrorReason: "Électeur créé, mais son mot de passe n'a pas pu être défini : {{reason}}",
                },
                delete: {
                    body: "Êtes-vous sûr de vouloir supprimer cet électeur ?",
                    bulkBody: "Êtes-vous sûr de vouloir supprimer les électeurs sélectionnés ?",
                    bulkBodySelected: "Supprimer les {{count}} électeurs sélectionnés ? Cette action est irréversible.",
                    bulkBodyChoose: "{{count}} électeurs sont sélectionnés. Vous pouvez plutôt supprimer tous les électeurs correspondant aux filtres actuels, qui peuvent être plus nombreux. Cette action est irréversible.",
                    okSelected: "Supprimer les {{count}} sélectionnés",
                    okAllMatching: "Supprimer tous les résultats correspondants",
                },
                notifications: {
                    exportError: "Erreur lors de l'exportation des électeurs",
                    deleteError: "Erreur lors de la suppression de l'électeur",
                    deleteSuccess: "Électeur supprimé",
                    multipleDeleteSuccess: "Électeurs supprimés",
                    manualVerificationError: "Erreur lors de la vérification manuelle de l'électeur",
                    manualVerificationSuccess: "Électeur vérifié manuellement avec succès, télécharger PDF..",
                },
            },
            roles: {
                title: "Rôles",
                edit: {
                    title: "Informations sur le Rôle",
                    subtitle: "Voir et éditer le Rôle",
                },
                create: {
                    title: "Rôle",
                    subtitle: "Créer rôle",
                },
                errors: {
                    createError: "Erreur lors de la création du rôle",
                    createSuccess: "Rôle créé",
                },
                fields: {
                    name: "Nom",
                },
                delete: {
                    body: "Êtes-vous sûr de vouloir supprimer ce rôle ?",
                },
                notifications: {
                    deleteError: "Erreur lors de la suppression du rôle",
                    deleteSuccess: "Rôle supprimé",
                    permissionEditError: "Erreur lors de l'édition de la permission",
                    permissionEditSuccess: "Permission éditée",
                },
            },
            permissions: {
                "voter-information-letter": "Générer une Lettre d'information de l'électeur",
                "admin-user": "Administration",
                "admin-dashboard-view": "Vue du Tableau de Bord d'Administration",
                "application-export": "Exportation d'Applications",
                "application-import": "Importation d'Applications",
                "tenant-create": "Créer Locataire",
                "tenant-read": "Lire Locataire",
                "tenant-write": "Éditer Locataire",
                "tenant-delete": "Supprimer Locataire",
                "election-event-create": "Créer Événement Électoral",
                "election-event-read": "Lire Événement Électoral",
                "election-event-write": "Éditer Événement Électoral",
                "keycloak-realm-attributes-read": "Lire les attributs du realm Keycloak",
                "keycloak-realm-attributes-write": "Modifier les attributs du realm Keycloak",
                "election-event-delete": "Supprimer Événement Électoral",
                "voter-create": "Créer Électeur",
                "voter-read": "Lire Électeur",
                "voter-write": "Éditer Électeur",
                "voter-secret-attribute-read": "Afficher les Champs Secrets de l'Électeur",
                "voter-secret-attribute-write": "Éditer les Champs Secrets de l'Électeur",
                "user-create": "Créer Utilisateur",
                "user-read": "Lire Utilisateur",
                "user-write": "Éditer Utilisateur",
                "user-permission-create": "Créer Permission d'Utilisateur",
                "user-permission-read": "Lire Permission d'Utilisateur",
                "user-permission-write": "Éditer Permission d'Utilisateur",
                "role-create": "Créer Rôle",
                "role-read": "Lire Rôle",
                "role-write": "Éditer Rôle",
                "role-assign": "Assigner Rôle",
                "communication-template-create": "Créer Modèle de Communication",
                "communication-template-read": "Lire Modèle de Communication",
                "communication-template-write": "Éditer Modèle de Communication",
                "notification-read": "Lire Notification",
                "notification-write": "Éditer Notification",
                "notification-send": "Envoyer Notification",
                "area-read": "Lire Zone",
                "area-write": "Éditer Zone",
                "election-state-write": "Éditer État de l'Élection",
                "election-type-create": "Créer Type d'Élection",
                "election-type-read": "Lire Type d'Élection",
                "election-type-write": "Éditer Type d'Élection",
                "voting-channel-read": "Lire Canal de Vote",
                "voting-channel-write": "Éditer Canal de Vote",
                "trustee-create": "Créer Fideicomisario",
                "trustee-read": "Lire Fideicomisario",
                "trustee-write": "Éditer Fideicomisario",
                "tally-read": "Lire Comptage",
                "tally-start": "Commencer Comptage",
                "tally-write": "Éditer Comptage",
                "tally-results-read": "Lire Résultats de Comptage",
                "publish-read": "Lire Publication",
                "publish-write": "Éditer Publication",
                "publish-results-read": "Lire Publication des Résultats",
                "publish-results-write": "Éditer Publication des Résultats",
                "logs-read": "Lire Journaux",
                "tasks-read": "Lire l'Exécution des Tâches",
                "keys-read": "Lire Clés",
                "document-upload": "Télécharger Documents",
                "document-download": "Télécharger Documents",
                "document-password-read": "Lire les mots de passe des documents",
                "tally-sheet-create": "Créer Acte de Comptage",
                "tally-sheet-import-create": "Créer une importation d'actes de comptage",
                "tally-sheet-import-review": "Examiner une importation d'actes de comptage",
                "tally-sheet-import-view": "Voir une importation d'actes de comptage",
                "tally-recount-execute": "Exécuter un recomptage des résultats",
                "trustee-ceremony": "Cérémonie de Fideicomisario",
                "tally-sheet-review": "Examiner la feuille de décompte",
                "tally-sheet-view": "Voir Acte de Comptage",
                "admin-ceremony": "Administrer Cérémonie de Clés",
                "tally-sheet-delete": "Supprimer Acte de Comptage",
                "cast-vote-read": "Lire Votes Émis",
                "document-read": "Lire Documents",
                "document-write": "Éditer Documents",
                "support-material-read": "Lire Matériaux de Support",
                "support-material-write": "Éditer Matériaux de Support",
                "miru-create": "Créer Miru",
                "miru-download": "Télécharger Miru",
                "miru-send": "Envoyer Miru",
                "miru-sign": "Signer Miru",
                "contest-write": "Éditer le Scrutin",
                "contest-read": "Lire le Scrutin",
                "candidate-write": "Éditer le candidats",
                "candidate-read": "Lire le candidats",
                "permission-label-write": "Modifier l'étiquette de permission",
                "scheduled-event-write": "Modifier des Événements Planifiés",
                "contest-create": "Créer un Scrutin",
                "contest-delete": "Supprimer le Scrutin",
                "candidate-create": "Créer un Candidat",
                "candidate-delete": "Supprimer le Candidat",
                "election-create": "Créer une Élection",
                "election-read": "Lire l'Élection",
                "election-write": "Modifier l'Élection",
                "election-delete": "Supprimer l'Élection",
                "election-event-archive": "Archiver l'Événement Électoral",
                "election-data-tab": "Voir les Données de l'Élection",
                "election-event-areas-tab": "Voir les Zones de l'Événement Électoral",
                "election-event-data-tab": "Voir les Données de l'Événement Électoral",
                "election-event-keys-tab": "Voir les Clés de l'Événement Électoral",
                "election-event-logs-tab": "Voir les Journaux de l'Événement Électoral",
                "election-event-publish-tab": "Voir la Publication de l'Événement Électoral",
                "election-event-reports-tab": "Voir les Rapports de l'Événement Électoral",
                "election-event-scheduled-tab": "Voir le Programme de l'Événement Électoral",
                "election-event-tally-tab": "Voir le Décompte de l'Événement Électoral",
                "election-event-tasks-tab": "Voir les Tâches de l'Événement Électoral",
                "election-event-voters-tab": "Voir les Électeurs de l'Événement Électoral",
                "election-publish-tab": "Voir la Publication de l'Élection",
                "election-voters-tab": "Voir les Électeurs de l'Élection",
                "report-write": "Modifier les Rapports",
                "report-read": "Lire les Rapports",
                "users-menu": "Voir les utilisateurs et les rôles",
                "settings-menu": "Voir les paramètres",
                "templates-menu": "Voir les modèles",
                "settings-election-types-tab": "Voir les paramètres des types d'élection",
                "settings-voting-channels-tab": "Voir les paramètres des canaux de vote",
                "settings-templates-tab": "Voir les paramètres des modèles",
                "settings-languages-tab": "Voir les paramètres des langues",
                "settings-localization-tab": "Voir les paramètres de localisation",
                "settings-look-feel-tab": "Voir les paramètres d'apparence",
                "settings-trustees-tab": "Voir les paramètres des fiduciaires",
                "settings-countries-tab": "Voir les paramètres des pays",
                "voter-import": "Importer un Électeur",
                "ee-voters-columns": "Voir les Colonnes des Électeurs de l'Événement Électoral",
                "voter-manually-verify": "Vérifier un Électeur Manuellement",
                "ee-voters-logs": "Voir les Journaux des Électeurs de l'Événement Électoral",
                "voter-export": "Exporter un Électeur",
                "ee-voters-filters": "Voir les Filtres des Électeurs de l'Événement Électoral",
                "voter-delete": "Supprimer un Électeur",
                "voter-change-password": "Changer le Mot de Passe de l'Électeur",
                "election-event-localization-selector": "Sélecteur de Localisation de l'Événement Électoral",
                "localization-create": "Créer une Localisation",
                "localization-read": "Lire une Localisation",
                "localization-write": "Modifier une Localisation",
                "localization-delete": "Supprimer une Localisation",
                "area-create": "Créer une Zone",
                "area-delete": "Supprimer une Zone",
                "area-export": "Exporter une Zone",
                "area-import": "Importer une Zone",
                "area-upsert": "Insérer ou Mettre à Jour une Zone",
                "election-event-areas-columns": "Colonnes des Zones de l'Événement Électoral",
                "election-event-areas-filters": "Filtres des Zones de l'Événement Électoral",
                "election-event-tasks-back-button": "Retour aux Tâches de l'Événement Électoral",
                "election-event-tasks-columns": "Colonnes des Tâches de l'Événement Électoral",
                "election-event-tasks-filters": "Filtres des Tâches de l'Événement Électoral",
                "task-export": "Exporter les Tâches",
                "application-read": "Lire l'Application",
                "application-write": "Modifier l'Application",
                "logs-export": "Exporter les Journaux",
                "election-event-logs-columns": "Colonnes des Journaux de l'Événement Électoral",
                "election-events-logs-filters": "Filtres des Journaux de l'Événement Électoral",
                "election-event-scheduled-event-columns": "Colonnes des Événements Programmés de l'Événement Électoral",
                "scheduled-event-create": "Créer un Événement Programmé",
                "scheduled-event-delete": "Supprimer un Événement Programmé",
                "election-event-reports-columns": "Colonnes des Rapports de l'Événement Électoral",
                "report-create": "Créer un Rapport",
                "report-delete": "Supprimer un Rapport",
                "report-generate": "Générer un Rapport",
                "report-preview": "Aperçu du Rapport",
                "monitor-authenticated-voters": "Surveillance des Électeurs Authentifiés",
                "monitor-all-approve-disapprove-voters": "Lire la Surveillance des Électeurs Approuvés et Refusés",
                "monitor-automatic-approve-disapprove-voters": "Lire la Surveillance des Approbations et Refus Automatiques",
                "monitor-manually-approve-disapprove-voters": "Lire la Surveillance des Approbations et Refus Manuels",
                "monitor-enrolled-overseas-voters": "Lire la Surveillance des Électeurs Inscrits à l'Étranger",
                "monitor-posts-already-closed-voting": "Lire la Surveillance des Publications avec Vote Clos",
                "monitor-posts-already-generated-election-results": "Lire la Surveillance des Publications avec Résultats Générés",
                "monitor-posts-already-opened-voting": "Lire la Surveillance des Publications avec Vote Ouvert",
                "monitor-posts-already-started-counting-votes": "Lire la Surveillance des Publications qui ont Commencé le Décompte des Votes",
                "monitor-posts-initialized-the-system": "Lire la Surveillance des Publications qui ont Initialisé le Système",
                "monitor-posts-started-voting": "Lire la Surveillance des Publications qui ont Commencé à Voter",
                "monitor-posts-transmitted-results": "Lire la Surveillance des Publications qui ont Transmis des Résultats",
                "monitor-voters-voted-test-election": "Lire la Surveillance des Électeurs lors de l'Élection de Test",
                "monitor-voters-who-voted": "Lire la Surveillance des Électeurs qui ont Voté",
                "election-event-publish-preview": "Aperçu de la Publication de l'Événement Électoral",
                "election-event-publish-back-button": "Retour à la Publication de l'Événement Électoral",
                "election-event-publish-columns": "Colonnes de la Publication de l'Événement Électoral",
                "election-event-publish-filters": "Filtres de la Publication de l'Événement Électoral",
                "publish-create": "Créer une Publication",
                "publish-regenerate": "Régénérer une Publication",
                "publish-export": "Exporter une Publication",
                "publish-start-voting": "Commencer le Vote",
                "publish-pause-voting": "Mettre en Pause le Vote",
                "publish-stop-voting": "Arrêter le Vote",
                "publish-changes": "Publier les Modifications",
                "election-event-publish-view": "Voir la Publication de l'Événement Électoral",
                "election-event-keys-columns": "Colonnes des Clés de l'Événement Électoral",
                "create-ceremony": "Créer une Cérémonie",
                "export-ceremony": "Exporter une Cérémonie",
                "election-event-tally-columns": "Colonnes du Décompte de l'Événement Électoral",
                "election-event-tally-back-button": "Retour au Décompte de l'Événement Électoral",
                "transmition-ceremony": "Cérémonie de Transmission",
                "admin-ip-address-view": "Voir l'adresse IP",
                "election-approvals-tab": "Voir les Approbations de l'Élection",
                "election-event-approvals-tab": "Voir les Approbations de l'Événement Électoral",
                "election-ip-address-view": "Voir l'adresse IP de l'Élection",
                "election-dashboard-tab": "Voir le Tableau de Bord de l'Élection",
                "trustees-export": "Exporter les Fiduciaires",
                "user-import": "Importer des Utilisateurs",
                "voter-voted-edit": "Modifier les électeurs qui ont voté",
                "voter-email-tlf-edit": "Modifier les champs e-mail/téléphone des électeurs",
                "cloudflare-write": "Modifier les règles de blocage par pays dans Cloudflare",
                "transmission-report-generate": "Générer un rapport de transmission",
                "google-meet-link": "Générer un Lien Google Meet",
                "service-account": "Compte de service",
                "datafix-account": "Compte de correction des données",
                "gold": "Or",
                "silver": "Argent",
                "election-event-ivr-tab": "Afficher l’IVR de l’événement électoral",
                "election-event-cas-tab": "Afficher le CAS de l’événement électoral",
                "ca-read": "Consulter les autorités de certification",
                "ca-write": "Modifier les autorités de certification",
                "generate-preview": "Générer l’aperçu",
                "preview-read": "Consulter l’aperçu",
                "tally-resolution-submit": "Soumettre la résolution du dépouillement",
                "phone-blacklist-read": "Consulter la liste noire téléphonique",
                "phone-blacklist-create": "Créer des entrées dans la liste noire téléphonique",
                "phone-blacklist-update": "Modifier des entrées de la liste noire téléphonique",
                "phone-blacklist-delete": "Supprimer des entrées de la liste noire téléphonique",
                "election-event-voter-list-reconciliation": "Rapprocher la liste électorale de l’événement",
            },
        },
        generalSettingsScreen: {
            body: "Activez les langues dans le système. Seules les langues activées ici seront disponibles pour les événements électoraux.",
        },
        eventsScreen: {
            title: "Événements Planifiés",
            subtitle: "Gère la configuration de l'exécution automatique des événements tels que le début ou la fin de la période de vote.",
            messages: {
                createSuccess: "Événement Planifié créé avec succès",
                createError: "Erreur lors de la création de l'Événement Planifié",
                editSuccess: "Événement Planifié modifié avec succès",
                editError: "Erreur lors de la modification de l'Événement Planifié",
                onlineWithEarlyVoting: "Une planification de début ne peut pas ouvrir à la fois le vote en ligne et le vote anticipé : le vote anticipé doit commencer avant le vote en ligne.",
            },
            eventType: {
                label: "Type",
                ALLOW_INIT_REPORT: "Autoriser le rapport d'initialisation",
                START_VOTING_PERIOD: "Début de la Période de Vote",
                END_VOTING_PERIOD: "Fin de la Période de Vote",
                ALLOW_VOTING_PERIOD_END: "Autoriser la fin de la période de vote",
                START_ENROLLMENT_PERIOD: "Début de la période d'inscription",
                END_ENROLLMENT_PERIOD: "Fin de la période d'inscription",
                START_LOCKDOWN_PERIOD: "Début de la période de blocage des données du recensement",
                END_LOCKDOWN_PERIOD: "Fin de la période de blocage des données du recensement",
                ALLOW_TALLY: "Autoriser le décompte",
            },
            election: {
                label: "Élection",
            },
            empty: {
                header: "Pas encore d'Événements Planifiés.",
                body: "Voulez-vous en créer un ?",
                button: "Créer un Événement Planifié",
            },
            create: {
                title: "Créer un Événement Planifié",
                subtitle: "Créer une nouvelle configuration d'Événement Planifié.",
            },
            edit: {
                title: "Modifier l'Événement Planifié",
                subtitle: "Modifier la configuration de l'Événement Planifié.",
                delete: "Êtes-vous sûr de vouloir supprimer cet Événement Planifié ?",
            },
            fields: {
                electionId: "Élection",
                eventProcessor: "Type",
                stoppedAt: "Arrêté Le",
                scheduledDate: "Planifié Le",
            },
        },
        reportsScreen: {
            title: "Rapports",
            subtitle: "Générer des rapports pour les événements électoraux",
            messages: {
                createSuccess: "Rapport créé avec succès",
                createError: "Erreur lors de la création du rapport",
                submitError: "Erreur lors de la soumission du Rapport",
                updateSuccess: "Rapport mis à jour avec succès",
                passwordMismatch: "Le mot de passe et la confirmation ne correspondent pas. Veuillez vous assurer que les deux champs contiennent le même mot de passe.",
                incorectPassword: "Le mot de passe est incorrect",
                decryptFileTitle: "Déchiffrer le fichier",
                decryptInstructions: "1. '-in' : Le chemin vers le fichier chiffré. \n2. '-out' : Le chemin où le fichier déchiffré sera enregistré. \n3. '-pass' : Le mot de passe utilisé pour chiffrer le fichier. \n",
                encryptSuccess: "Configuration du chiffrement du rapport réussie",
                encryptError: "Erreur lors de la configuration du chiffrement du rapport",
            },
            reportType: {
                BALLOT_RECEIPT: "Reçu de Bulletin",
                ELECTORAL_RESULTS: "Résultats Électoraux",
                MANUAL_VERIFICATION: "Vérification Manuelle",
                PARTICIPATION_REPORT: "Rapport de Participation",
                STATISTICAL_REPORT: "Rapport Statistique",
                OVCS_EVENTS: "Suivi du Vote à l'Étranger - Événements OVCS",
                AUDIT_LOGS: "Journaux d'Audit",
                ACTIVITY_LOG: "Journaux d'Activité",
                STATUS: "Statut",
                OVCS_INFORMATION: "Informations OVCS",
                OVERSEAS_VOTERS: "Liste des Électeurs Résidant à l'Étranger",
                OV_USERS_WHO_VOTED: "Liste des Électeurs Résidant à l'Étranger ayant Voté",
                OV_WITH_VOTING_STATUS: "Liste des Électeurs Résidant à l'Étranger avec Statut de Vote",
                OVCS_STATISTICS: "Suivi du Vote à l'Étranger - Statistiques OVCS",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Liste des Électeurs Résidant à l'Étranger Pré-inscrits mais Refusés",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Liste des Électeurs Résidant à l'Étranger Pré-inscrits mais Soumis à Validation Manuelle",
            },
            reportEncryptionPolicy: {
                title: "Politique de chiffrement",
                UNENCRYPTED: "Non chiffré",
                CONFIGURED_PASSWORD: "Mot de passe configuré",
            },
            empty: {
                header: "Pas encore de rapports.",
                body: "Voulez-vous en créer un?",
                button: "Créer un rapport",
            },
            create: {
                title: "Créer un rapport",
                subtitle: "Créer une nouvelle configuration de rapport.",
            },
            edit: {
                title: "Modifier le rapport",
                subtitle: "Modifier la configuration du rapport.",
                delete: "Êtes-vous sûr de vouloir supprimer ce rapport?",
            },
            fields: {
                electionId: "Élection",
                template: "Modèle",
                reportType: "Type de rapport",
                repeatable: "Répétable",
                cronExpression: "Expression Cron",
                emailRecipients: "Destinataires de courriel",
                emailRecipientsPlaceholder: "Tapez l'email et appuyez sur Entrée",
            },
            delete: {
                body: "Êtes-vous sûr de vouloir supprimer ce rapport?",
            },
            actions: {
                generate: "Générer",
                delete: "Supprimer",
                edit: "Modifier",
                preview: "Aperçu",
            },
        },
        googleMeet: {
            title: "Générer un Lien Google Meet",
            generateButton: "Google Meet",
            meetingTitle: "Titre de la Réunion",
            description: "Description (Optionnel)",
            startDate: "Date de Début",
            startTime: "Heure de Début",
            duration: "Durée (minutes)",
            attendeeEmails: "Emails des Participants",
            attendeeEmailHelp: "Emails séparés par des virgules pour les participants de la réunion",
            note: "Note : Cela créera un événement de calendrier dans votre Google Calendar avec un lien Google Meet. Vous devrez vous connecter à votre compte Google.",
            success: "Lien Google Meet Généré avec Succès !",
            copy: "Copier dans le presse-papiers",
            copied: "Lien copié dans le presse-papiers !",
            instructions: "Partagez ce lien avec les participants pour rejoindre la réunion. L'événement de calendrier a été ajouté à votre Google Calendar.",
            generating: "Génération...",
            generate: "Générer le Lien Meet",
        },
        common: {
            export: "L'exportation peut être un processus long. Êtes-vous sûr de vouloir exporter ?",
            resources: {
                electionEvent: "Événement Électoral",
                election: "Élection",
                contest: "Scrutin",
                candidate: "Candidat",
                noResult: {
                    askCreate: "Voulez-vous en créer un ?",
                },
            },
            label: {
                add: "Ajouter",
                actions: "Actions",
                create: "Créer",
                delete: "Supprimer",
                archive: "Archiver",
                unarchive: "Désarchiver",
                cancel: "Annuler",
                edit: "Éditer",
                yes: "Oui",
                no: "Non",
                save: "Sauvegarder",
                close: "Fermer",
                back: "Retour",
                next: "Suivant",
                warning: "Avertissement",
                json: "Aperçu JSON",
                noResult: "Aucun résultat",
                import: "Importer",
                export: "Exporter",
                loadingData: "Chargement des données ...",
                exportFormat: "Exporter au format {{format}} - Résultats de '{{item}}",
                allResults: "de l'événement électoral",
                globalAreaResults: "de toutes les zones",
                title: "Titre",
                subtitle: "Sous-titre",
                kind: "Type de fichier",
                filter: "Filtres personnalisés",
                approve: "Approuver",
                continue: "Continuer",
                logout: "Déconnexion",
                selectTenant: "Sélectionner un locataire",
                processing: "Traitement en cours...",
                tenantName: "Nom du locataire",
            },
            language: {
                es: "Espagnol",
                en: "Anglais",
                fr: "Français",
                cat: "Valencien",
                tl: "Tagalog",
                gl: "Galego",
                nl: "Néerlandais",
                eu: "Euskera",
            },
            channel: {
                online: "En ligne",
                kiosk: "Kiosque",
                early_voting: "Vote anticipé",
                telephone: "Vote par téléphone",
                other: "Autre",
            },
            message: {
                delete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
                continueOrLogout: "Voulez-vous continuer ou vous déconnecter ?",
            },
        },
        createResource: {
            electionEvent: "Créer un Événement Électoral",
            election: "Créer une Élection",
            contest: "Créer un Scrutin",
            candidate: "Créer un Candidat",
            slate: "Créer une Liste",
        },
        importResource: {
            electionEvent: "Importer un Événement Électoral",
            election: "Importer une Élection",
            contest: "Importer un Scrutin",
            candidate: "Importer un Candidat",
            ImportHashMismatch: "Les empreintes ne correspondent pas. Échec du contrôle d'intégrité.",
        },
        sideMenu: {
            electionEvents: "Processus Électoraux",
            search: "Chercher",
            usersAndRoles: "Utilisateurs et Rôles",
            logs: "Journaux",
            settings: "Configuration",
            help: "Aide",
            templates: "Modèles",
            active: "Actifs",
            archived: "Archivés",
            addResource: {
                electionEvent: "Créer un Événement Électoral",
                election: "Créer une Élection",
                contest: "Créer un Scrutin",
                candidate: "Créer un Candidat",
            },
            menuActions: {
                archive: {
                    electionEvent: "Archiver cet Événement Électoral",
                },
                unarchive: {
                    electionEvent: "Désarchiver cet Événement Électoral",
                    election: "Désarchiver cette Élection",
                    contest: "Désarchiver ce Scrutin",
                    candidate: "Désarchiver ce Candidat",
                },
                remove: {
                    electionEvent: "Supprimer cet Événement Électoral",
                    election: "Supprimer cette Élection",
                    contest: "Supprimer ce Scrutin",
                    candidate: "Supprimer ce Candidat",
                    slate: "Supprimer cette Liste",
                },
                messages: {
                    confirm: {
                        archive: "Êtes-vous sûr de vouloir archiver cet élément ?",
                        unarchive: "Êtes-vous sûr de vouloir désarchiver cet élément ?",
                        delete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
                        archiveNamed: 'Êtes-vous sûr de vouloir archiver "{{name}}" ?',
                        unarchiveNamed: 'Êtes-vous sûr de vouloir désarchiver "{{name}}" ?',
                        deleteNamed: 'Êtes-vous sûr de vouloir supprimer "{{name}}" ?',
                    },
                    notification: {
                        success: {
                            archive: "L'élément a été archivé",
                            unarchive: "L'élément a été désarchivé",
                            delete: "L'élément a été supprimé",
                            reloading: "Veuillez patienter. La page va se recharger dans quelques instants.",
                        },
                        error: {
                            archive: "Erreur lors de la tentative d'archivage de cet élément",
                            unarchive: "Erreur lors de la tentative de désarchivage de cet élément",
                            delete: "Erreur lors de la tentative de suppression de cet élément",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Configuration des candidats.",
            },
            edit: {
                externalId: "ID externe",
                general: "Général",
                type: "Type",
                image: "Image",
                isDisabled: "Désactivé",
                isExplicitInvalid: "Vote Inválido",
                isExplicitBlank: "Vote Blanc",
                isCategoryList: "Liste",
                isWriteIn: "Vote par Écrit",
            },
            field: {
                name: "Nom",
                alias: "Alias",
                description: "Description",
            },
            options: {
                "candidate": "Candidat",
                "option": "Option",
                "write-in": "Vote par Écrit",
                "open-list": "Liste Ouverte",
                "closed-list": "Liste Fermée",
                "semi-open-list": "Liste Semi-ouverte",
                "invalid-vote": "Vote Inválido",
                "blank-vote": "Vote Blanc",
            },
            invalidVotePosition: {
                label: "Position du Vote Invalide",
                null: "Aucune (Par défaut)",
                top: "Haut",
                bottom: "Bas",
            },
            error: {},
            createCandidateSuccess: "Candidat créé",
            createCandidateError: "Erreur lors de la création du candidat",
        },
        slateScreen: {
            common: {
                subtitle: "Configuration de la liste.",
                newSlate: "Nouvelle liste",
                notFound: "Cette liste n'existe pas.",
            },
            tabs: {
                data: "Données",
            },
            edit: {
                general: "Général",
                members: "Membres",
            },
            field: {
                name: "Nom",
                alias: "Alias",
                description: "Description",
                externalId: "ID externe",
            },
            members: {
                helper: "Attribuez jusqu'au nombre maximal de candidats de chaque scrutin. Laissez un scrutin vide pour que cette liste n'y présente personne. Les candidats qui ne figurent sur aucune liste apparaissent comme Indépendants dans ce scrutin.",
                contest: "Scrutin",
                candidate: "Candidat",
                noCandidate: "Aucun candidat",
            },
            messages: {
                saved: "Liste enregistrée",
                invalid: "La liste ne peut pas être enregistrée. Corrigez les problèmes indiqués ci-dessous.",
                error: "La liste n'a pas pu être enregistrée.",
                unreadable: "La configuration des listes de l'élection ne peut pas être lue.",
            },
        },
        contestScreen: {
            common: {
                subtitle: "Configuration du scrutin.",
            },
            edit: {
                externalId: "ID externe",
                general: "Général",
                type: "Type",
                image: "Image",
                system: "Système de vote de bulletins",
                design: "Design du bulletin",
                reorder: "Réorganiser les candidats",
                policies: "Politiques",
            },
            field: {
                name: "Nom",
                alias: "Alias",
                description: "Description",
            },
            options: {
                "non-preferential": "Sans Préférence",
                "plurality-at-large": "Pluralité Générale",
                "instant-runoff": "Vote à Second Tour Instantané",
                "random": "Aléatoire",
                "external-procedure": "Procédure externe",
                "custom": "Personnalisé",
                "alphabetical": "Alphabétique",
            },
            tieBreakingPolicy: {
                label: "Politique de départage",
            },
            auditButtonConfig: {
                "label": "Options d'affichage du bouton d'audit",
                "show": "Afficher",
                "not-show": "Ne pas afficher",
                "show-in-help": "Afficher dans la boîte de dialogue d'aide",
            },
            underVotePolicy: {
                "label": "Politique de Sous-Vote",
                "allowed": "Autorisé",
                "warn-only-in-review": "Avertir en Révision",
                "warn": "Avertir",
                "warn-and-alert": "Avertir et Alerter",
                "warn-and-confirm-in-review": "Avertir et Confirmer en Révision",
            },
            invalidVotePolicy: {
                "label": "Politique de vote invalide",
                "allowed": "Permis",
                "warn": "Avertissement",
                "warn-invalid-implicit-and-explicit": "Avertir Inválidos Implicites et Explicites",
                "not-allowed": "Non Permis",
                "allowed-with-exclusive-explicit": "Permis avec Vote Invalide Explicite Exclusif",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Forme d’icône de case à cocher pour les candidats",
                "square-checkbox": "Case à cocher carrée",
                "round-checkbox": "Case à cocher ronde",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Candidats Et Listes",
                "allow-selecting-candidates": "Seulement Candidats",
                "allow-selecting-lists": "Seulement Listes",
                "disabled": "Désactivé",
            },
            collapsibleListsPolicy: {
                "label": "Listes repliables",
                "disabled": "Désactivé",
                "enabled-expanded": "Activé (commence déplié)",
                "enabled-collapsed": "Activé (commence replié)",
            },
            blankVotePolicy: {
                "label": "Politique de vote blanc",
                "allowed": "Autorisé",
                "warn-only-in-review": "Avertir en Révision",
                "warn": "Avertir",
                "not-allowed": "Non autorisé",
            },
            overVotePolicy: {
                "label": "Politique de vote excessive",
                "allowed": "Autorisé",
                "allowed-with-msg": "Autorisé avec un message d'avertissement",
                "allowed-with-msg-and-alert": "Autorisé avec un message d'avertissement et d'alerte",
                "not-allowed-with-msg-and-alert": "Non autorisé avec un message d'avertissement et d'alerte",
                "not-allowed-with-msg-and-disable": "Non autorisé avec un message d'avertissement et désactiver d'autres sélections",
            },
            duplicatedRankPolicy: {
                "label": "Vote invalide - Politique de rang dupliqué",
                "allowed-warn-and-dialog": "Afficher avertissement et dialogue (l'électeur peut continuer)",
                "not-allowed-warn-and-dialog": "Afficher avertissement et dialogue (l'électeur n'est pas autorisé à continuer)",
            },
            preferenceGapsPolicy: {
                "label": "Vote invalide - Politique de rangs ignorés",
                "allowed-warn-and-dialog": "Afficher avertissement et dialogue (l'électeur peut continuer)",
                "not-allowed-warn-and-dialog": "Afficher avertissement et dialogue (l'électeur n'est pas autorisé à continuer)",
            },
            paginationPolicy: {
                label: "Nom de la page",
            },
            isAcclaimed: {
                label: "Acquis par acclamation",
                helperText: "Les électeurs voient ce scrutin mais ne peuvent rien sélectionner, rien n'est enregistré et tous les candidats sont déclarés élus avec zéro voix. À définir avant la publication des bulletins : le modifier ensuite invalide les bulletins déjà déposés.",
            },
            allowWriteins: {
                label: "Autoriser les candidatures manuscrites",
            },
            maxVotes: {
                helperText: "Nombre maximum de candidats qu'un électeur peut sélectionner (vote non préférentiel).",
                helperTextPreferential: "Position de classement la plus haute disponible (ex. '5' signifie positions 1 à 5). Doit être au moins égal au nombre de candidats à classer (vote préférentiel).",
            },
            error: {},
            createContestSuccess: "Scrutin créé",
            createContestError: "Erreur lors de la création du scrutin",
        },
        keysGeneration: {
            configureStep: {
                create: "Créer une Cérémonie de Clés",
                name: "Nom de la Cérémonie des Clés",
                allElections: "Toutes les Élections",
                title: "Créer une Cérémonie de Clés de l'Événement Électoral",
                subtitle: "Dans cette cérémonie, chaque autorité générera et téléchargera sa part des clés privées pour l'Événement Électoral. Pour continuer, choisissez les autorités qui participeront à la cérémonie et le seuil, qui est le nombre minimum d'autorités nécessaires pour compter.",
                trusteeList: "Autorités",
                threshold: "Seuil",
                errorMinTrustees_one: "Vous avez sélectionné seulement {{selected}} autorité, mais vous devez en sélectionner au moins {{threshold}}.",
                errorMinTrustees_many: "Vous avez sélectionné seulement {{selected}} autorités, mais vous devez en sélectionner au moins {{threshold}}.",
                errorMinTrustees_other: "Vous avez sélectionné seulement {{selected}} autorités, mais vous devez en sélectionner au moins {{threshold}}.",
                errorThreshold: "Vous avez sélectionné un seuil de {{selected}} mais il doit être entre {{min}} et {{max}}.",
                errorCreatingCeremony: "Erreur lors de la création de la Cérémonie de Clés : {{error}}",
                createCeremonySuccess: "Cérémonie de Clés créée",
                confirmdDialog: {
                    ok: "Oui, Créer une Cérémonie de Clés",
                    cancel: "Annuler",
                    title: "Êtes-vous sûr de vouloir Créer une Cérémonie de Clés ?",
                    automaticCeremonyTitle: "Êtes-vous sûr de vouloir créer une cérémonie de clés automatique ?",
                    description: "Vous êtes sur le point de Créer une Cérémonie de Clés. Cette action notifiera aux Autorités de participer à la création et distribution des Clés de l'Événement Électoral.",
                    automaticCeremonyDescription: "Vous êtes sur le point de créer une cérémonie de clés automatique. Cela n'informera pas les fiduciaires de leur participation.",
                },
                filterTrustees: "Filtre des Autorités",
                errorPermisionLabels: "Impossible de créer la cérémonie de clés : une ou plusieurs étiquettes d’autorisations sont manquantes.",
                automaticCeremonyToggle: "Cérémonie automatique",
            },
            ceremonyStep: {
                cancel: "Annuler la Cérémonie de Clés",
                progressHeader: "Progrès de la Cérémonie de Clés",
                description: "Cet écran montre le progrès et les journaux de la Cérémonie de Clés de l'Événement Électoral. Dans la Cérémonie de Clés, chaque autorité générera et téléchargera son fragment de la clé privée pour l'Événement Électoral.",
                executionStatus: "État : {{status}}",
                confirmdDialog: {
                    ok: "Oui, Annuler la Création de la Cérémonie de Clés",
                    cancel: "Revenir à la Cérémonie de Clés",
                    title: "Êtes-vous sûr de vouloir Annuler la Cérémonie de Clés ?",
                    description: "Vous êtes sur le point d'Annuler la Cérémonie de Clés. Après avoir effectué cette action, pour avoir une Cérémonie de Clés réussie, vous devrez en Créer une nouvelle.",
                },
                header: {
                    trusteeName: "Nom de l'Autorité",
                    fragment: "Fragment de Clé Généré",
                    downloaded: "Fragment Privé de Clé Téléchargé",
                    checked: "Fragment Privé de Clé Vérifié",
                },
                logsHeader: {
                    title: "Journaux",
                    date: "Date",
                    entry: "Entrée",
                },
                emptyLogs: "Pas de journaux pour l'instant.",
            },
            startStep: {
                title: "Cérémonie de Clés de l'Autorité",
                subtitle: "Vous êtes sur le point de participer à la Cérémonie de Clés en tant qu'Autorité (<strong>{{name}}</strong>). Cela implique les étapes suivantes :",
                one: "<strong>Télécharger</strong> votre Clé Privée Cryptée.",
                two: "Créer plusieurs <strong>Copies de sauvegarde</strong> de votre Clé Privée Cryptée.",
                three: "<strong>Vérifier</strong> que les copies de sauvegarde fonctionnent correctement.",
            },
            downloadStep: {
                title: "Télécharger Clé Privée Cryptée",
                subtitle: "Pour continuer, veuillez télécharger et sauvegarder votre Clé Privée Cryptée sur au moins deux appareils différents :",
                downloadButton: "Télécharger votre Clé Privée Cryptée",
                downloaded: "Clé Privée Cryptée téléchargée avec succès.",
                errorEmptyKey: "Erreur de téléchargement, fichier vide",
                unexpectedError: "La clé privée n'a pas pu être téléchargée. Veuillez réessayer.",
                alreadyVerified: "Votre clé privée a déjà été téléchargée et vérifiée.",
                unavailable: "Le téléchargement de la clé privée n'est plus disponible car la cérémonie a progressé.",
                confirmdDialog: {
                    ok: "Confirmer les copies de sauvegarde et Continuer",
                    cancel: "Revenir",
                    title: "Copie de sauvegarde de votre Clé Privée Cryptée",
                    description: "Veuillez effectuer une copie de sauvegarde de votre Clé Privée Cryptée à au moins deux emplacements sécurisés différents et confirmez-le ensuite :",
                    firstCopy: "Première copie de sauvegarde réalisée",
                    secondCopy: "Deuxième copie de sauvegarde réalisée",
                    confirmError: "Créez les sauvegardes requises et cochez les cases de confirmation pour continuer",
                },
            },
            checkStep: {
                title: "Vérifiez vos Copies de Sauvegarde de votre Clé Privée Cryptée",
                verifyButton: "Vérifier la clé",
                subtitle: "Chargez la Copie de Sauvegarde de votre Clé Privée Cryptée pour vérifier qu'elle est correcte. Vous pouvez essayer autant de fois que nécessaire, depuis vos différentes copies de sauvegarde :",
                errorUploading: "Copa de Sauvegarde de la Clé Privée Cryptée invalide, veuillez réessayer",
                errorEmptyFile: "Fichier vide ou non trouvé",
                verified: "Copie de sauvegarde vérifiée avec succès.",
                alreadyRestored: "Votre clé avait déjà été restaurée.",
            },
        },
        miruExport: {
            create: {
                success: "",
                error: "",
            },
            send: {
                success: "",
                error: "",
            },
        },
        tally: {
            numericResultsReportsPending: "Les résultats numériques sont complets. Les rapports sont encore en cours de génération.",
            errorUploadingSignature: "Une erreur s'est produite lors du téléchargement de la signature",
            downloadTransmissionPackage: "Télécharger le paquet",
            resultsPublication: {
                sectionTitle: "Publier sur le site web des résultats",
                policyTitle: "Site web des résultats",
                policyAccess: "Accès au site web des résultats",
                policyVisibility: "Visibilité du site web des résultats",
                enabled: "Activé",
                disabled: "Désactivé",
                fullEvent: "Événement complet",
                areaBased: "Par zone",
                publishStarted: "Publication des résultats démarrée",
                publishError: "Impossible de démarrer la publication des résultats",
                revoked: "Publication des résultats révoquée",
                revokeError: "Impossible de révoquer la publication des résultats",
                waitingForTally: "Les résultats pourront être publiés une fois ce dépouillement terminé.",
                writePermissionRequired: "Vous avez besoin de la permission publish-results-write pour publier ou révoquer des résultats.",
                readPermissionRequired: "Vous avez besoin de la permission publish-results-read pour consulter l'historique des publications.",
                disabledPolicy: "La publication sur le site web des résultats est désactivée pour cet événement électoral. Activez-la dans les données de l'événement électoral avant de publier les résultats.",
                loadingElectionContext: "La publication des résultats charge le contexte de l'élection.",
                route: "Route",
                eventResults: "Résultats de l'événement",
                electionResults: "Résultats de l'élection",
                election: "Élection",
                access: "Accès",
                publicAccess: "Accès public",
                authenticatedAccess: "Accès authentifié",
                visibility: "Visibilité",
                fullPublishedScope: "Portée publiée complète",
                personalVisibility: "Visibilité personnelle",
                contests: "Scrutins",
                noTalliedContests: "Aucun scrutin dépouillé disponible.",
                publishSelectedContests: "Publier les scrutins sélectionnés",
                selectedContestCount_one: "{{count}} scrutin sélectionné",
                selectedContestCount_many: "{{count}} scrutins sélectionnés",
                selectedContestCount_other: "{{count}} scrutins sélectionnés",
                history: "Historique des publications",
                version: "Version",
                status: "Statut",
                published: "Publié",
                revokedAt: "Révoqué",
                actions: "Actions",
                open: "Ouvrir",
                revoke: "Révoquer",
                noPublications: "Aucune publication pour le moment.",
                confirmTitle: "Démarrer la publication sur le site web des résultats ?",
                confirmDescription: "Cela créera une nouvelle publication à partir du dépouillement actuel. Les résultats visibles par les électeurs restent actifs jusqu'à la réussite de cette tâche de publication.",
                close: "Fermer",
            },
            transmissionPackage: {
                title: "Paquet de Transmission pour la Zone '{{name}}' y Elección '{{eventName}}'",
                description: "Vous permet d'exporter un Paquet de Transmission vers des Serveurs de Destination ou de le télécharger.",
                actions: {
                    sign: {
                        title: "Régénérer",
                        dialog: {
                            title: "Voulez-vous signer le paquet de transmission ?",
                            description: "Veuillez confirmer que vous souhaitez régénérer le paquet de transmission pour la zone `{{name}}`",
                            confirm: "Signer le paquet de transmission",
                            cancel: "Fermer",
                            input: {
                                placeholder: "Entrez votre mot de passe",
                            },
                        },
                    },
                    send: {
                        title: "Envoyer",
                        dialog: {
                            title: "Voulez-vous envoyer le Paquet de Transmission?",
                            description: "Veuillez confirmer que vous souhaitez envoyer le Paquet de Transmission pour la Zone '{{name}}' aux Serveurs de Destination.",
                            confirm: "Envoyer le Paquet de Transmission",
                            cancel: "Fermer",
                        },
                    },
                    regenerate: {
                        title: "Régénérer",
                        dialog: {
                            title: "Voulez-vous régénérer le paquet de transmission?",
                            description: "Veuillez confirmer que vous souhaitez régénérer le paquet de transmission pour la zone `{{name}}`",
                            confirm: "Régénérer le paquet de transmission",
                            cancel: "Fermer",
                        },
                    },
                    download: {
                        title: "Télécharger",
                        emlTitle: "Télécharger EML {{date}}",
                        transmissionPackageTitle: "Télécharger le Paquet de Transmission {{date}}",
                        transmissionReportTitle: "Télécharger le rapport de transmission",
                        dialog: {
                            title: "Voulez-vous télécharger le Paquet de Transmission?",
                            description: "Veuillez confirmer que vous souhaitez télécharger le Paquet de Transmission pour la Zone '{{name}}.'",
                            confirm: "Télécharger le Paquet de Transmission",
                            cancel: "Fermer",
                        },
                    },
                },
                destinationServers: {
                    title: "Serveurs de Destination",
                    description: "Le tableau ci-dessous montre l'état d'envoi de chacun des Serveurs de Destination.",
                    status: "Envoyé à {{signed}} sur {{total}}",
                    table: {
                        serverName: "Nom du Serveur",
                        sendStatus: "État de l'Envoi",
                    },
                },
                signatures: {
                    title: "Signatures SBEI",
                    description: "Les SBEI peuvent signer le Paquet de Transmission. Le tableau ci-dessous montre l'état de signature de chacun des membres du SBEI.",
                    table: {
                        trusteeName: "Nom du Fiduciaire",
                        signed: "A Signé",
                    },
                    status: "{{signed}} sur {{total}} Ont Signé, minimum {{minimum}}",
                },
            },
            sendToTransmissionPackageServers: "Envoyer le paquet de transmission pour la zone '{{name}}'",
            uploadTransmissionPackage: "Télécharger",
            uploadTransmissionPackageDesc: "Téléchargez votre signature pour signer le paquet des Résultats Électoraux. Cette opération est optionnelle.",
            exportElectionArea: "Envoyer le paquet de transmission pour la zone '{{name}}'",
            generateReport: "Générer {{name}}",
            templateTitle: "Modèle de Résultats",
            templateSubTitle: "Éventuellement écraser le modèle de résultats.",
            keysCeremonyTitle: "Cérémonie des Clés",
            keysCeremonySubTitle: "Sélectionnez la Cérémonie des Clés pour ce dépouillement",
            ceremonyTitle: "Élections pour le Comptage",
            initializationTitle: "Élections pour le rapport d'initialisation",
            ceremonySubTitle: "Sélectionnez les élections pour le comptage",
            tallyTitle: "Progrès du Comptage des Élections",
            logsTitle: "Journaux",
            resultsTitle: "Résultats & Participation",
            generalInfoTitle: "Informations Générales",
            trusteeTallyTitle: "Trustee",
            trusteeTallySubTitle: "État d'importation du fragment de clé",
            eligibility: {
                selectElection: "Sélectionnez au moins une élection.",
                publishElection: "Publiez chaque élection sélectionnée avant de créer son dépouillement.",
                tallyDisallowed: "Le dépouillement est désactivé pour une élection sélectionnée.",
                endVoting: "Terminez le vote de chaque élection sélectionnée et arrêtez ses canaux actifs avant de créer le dépouillement.",
            },
            createTallySuccess: "Comptage créé",
            createTallyError: "Erreur lors de la création du comptage",
            startTallySuccess: "Comptage commencé",
            startTallyError: "Erreur lors du démarrage du comptage",
            startTallyCeremonySuccess: "Cérémonie de comptage commencée",
            startTallyCeremonyError: "Impossible de démarrer la cérémonie de comptage",
            cancelTallyCeremonySuccess: "Cérémonie de comptage annulée",
            cancelTallyCeremonyError: "Impossible d'annuler la cérémonie de comptage",
            recountTallyCeremony: "Recompter",
            recountTallyCeremonyMessage: "Cela générera un nouvel événement de résultats pour la session de comptage terminée.",
            recountTallyCeremonyStarting: "Démarrage du recomptage...",
            recountTallyCeremonySuccess: "Recomptage commencé",
            recountTallyCeremonyError: "Impossible de démarrer le recomptage",
            recountTallyCeremonyOk: "Recompter",
            trusteeTitle: "Processus du trustee",
            trusteeSubTitle: "Veuillez importer votre fragment de clé",
            invited: "Vous avez été invité à participer à une cérémonie de comptage. Veuillez, ",
            click: "cliquez sur l'action de comptage",
            participate: "pour participer.",
            breadcrumbSteps: {
                start: "Début",
                finish: "Fin",
                tally: "Comptage",
                results: "Résultats",
                ceremony: "Cérémonie",
            },
            common: {
                title: "Comptage",
                subTitle: "Configuration du Comptage.",
                cancel: "Arrière",
                next: "Suivant",
                date: "Date de Comptage",
                global: "Global",
                noTrustees: "Aucun trustee pour l'instant",
                imported: " trustees ont importé leur fragment de clé",
                needed: " trustees nécessaires pour le comptage",
                start: "Commencer Comptage",
                ceremony: "Commencer Cérémonie de Comptage",
                initialization: "Démarrer le rapport d'initialisation",
                results: "Résultats",
                dialog: {
                    ok: "Ok",
                    okTally: "Commencer comptage",
                    okCancel: "Annuler comptage",
                    cancel: "Fermer",
                    title: "Êtes-vous sûr de vouloir commencer une cérémonie ?",
                    tallyTitle: "Êtes-vous sûr de vouloir commencer le comptage ?",
                    cancelTitle: "Êtes-vous sûr de vouloir annuler le comptage ?",
                    message: "Vous êtes sur le point de commencer une cérémonie de comptage. Cette action notifiera aux trustees d'importer leurs fragments de clé.",
                    cancelMessage: "Vous êtes sur le point d'annuler la cérémonie de comptage. Cette action ne peut pas être annulée.",
                    ceremony: "Tous les trustees requis ont vérifié leurs fragments de clé. Tout est prêt pour commencer à recevoir les résultats. Voulez-vous commencer le Comptage ?",
                    startAutomatedTallyMessage: "Sélectionnez 'Start Tally' pour lancer le processus de décompte et afficher les résultats, ou 'Close' pour annuler.",
                },
            },
            table: {
                elections: "Élections",
                selected: "Sélectionnées",
                status: "État",
                progress: "Progrès",
                method: "Méthode de Comptage",
                elegible: "Votants Éligibles",
                number: "Nombre de Votes",
                total: "Total",
                turnout: "%",
                candidates: "Résultats des Candidats",
                options: "Options",
                global: "Résumé de participation",
                elegible_census: "Recensement des votants éligibles",
                cast_votes: "Nombre de Votes",
                cast_votes_percent: "Pourcentages de Votes",
                total_votes: "Total de votants",
                total_votes_percent: "Participation",
                total_votes_counted: "Total des Votes Comptés",
                total_auditable_votes: "Total des Votes Contrôlables",
                total_valid_votes: "Total de votes valides",
                total_valid_votes_percent: "Pourcentage de votes valides",
                total_invalid_votes: "Total de votes invalides",
                total_invalid_votes_percent: "Pourcentage de votes invalides",
                explicit_invalid_votes: "Votes explicitement invalides",
                explicit_invalid_votes_percent: "Pourcentage de votes explicitement invalides",
                implicit_invalid_votes: "Votes implicitement invalides",
                implicit_invalid_votes_percent: "Pourcentage de votes implicitement invalides",
                blank_votes: "Votes blancs",
                explicit_blank_votes: "Votes blancs explicites",
                implicit_blank_votes: "Votes blancs implicites",
                blank_votes_percent: "Pourcentage de votes blancs",
                number_of_votes: "Nombre de votes",
                winning_position: "Position gagnante",
                weight: "Poids",
                preferential: {
                    candidate: "Candidat",
                    winner: "Gagnant",
                    eliminated: "Éliminé",
                    round: "Tour",
                },
                total_declined_to_vote: "Total des refus de vote",
                total_blank_ballots: "Total des Bulletins Blancs",
                participation_by_channel: "Participation par canal",
                channel: "Canal",
                channel_online: "En ligne",
                channel_kiosk: "Kiosque",
                channel_early_voting: "Vote anticipé",
                channel_telephone: "Téléphone",
                channel_paper: "Papier",
                channel_postal: "Postal",
                channel_in_person: "En personne",
                acclamation_note: "Élu par acclamation. Ce scrutin a été tranché sans vote : aucune voix n'a été enregistrée.",
            },
            pendingResolutions: {
                round: "Tour {{round}}",
                tieResolutionRequired: "Résolution de partage requise",
                tieResolved: "Partage résolu",
                globalArea: "Global",
                pendingResolutionsHeader: "Résolutions en attente",
                pendingResolutionStatus: "Résolution en attente",
                resolvedStatus: "Résolue",
                resolutionTitle: "Résolution",
                selectContest: "Sélectionnez un élément à gauche pour voir les détails",
                selectCandidateToAdvance: "Sélectionnez le candidat à faire avancer",
                undoResolution: "Annuler la résolution",
                applyResolutions: "Appliquer les résolutions et recalculer",
                submitSuccess: "Résolutions soumises. Le comptage reprend...",
                submitError: "Échec de la soumission des résolutions. Veuillez réessayer.",
                filter: "Filtrer",
                save: "Enregistrer",
                pendingApplyStatus: "Calcul en attente",
                filterElection: "Élection",
                filterContest: "Scrutin",
                filterArea: "Zone",
                filterStatusLabel: "Statut",
                clearFilters: "Effacer les filtres",
                candidateWithVotes: "{{name}} ({{votes}} voix)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} voix, {{percent}}%)",
                tieInfoTitle: "Décompte pausé en raison d'une égalité non résolue (Tour {{round}})",
                tieInfoBody: "Candidats à égalité ({{votes}} voix, {{percent}}%) : {{candidates}}. Un départage manuel est requis pour continuer le décompte.",
                tallyResumedTitle: "Décompte repris après application de la résolution",
                tallyResumedBody: "L'égalité a été résolue le {{date}} par {{user}}",
            },
            chart: {
                votesForCandidates: "Votes pour les Candidats",
                blankVotes: "Votes Blancs",
                invalidVotes: "Votes Invalides",
                totalVoters: "Total des Électeurs",
                nonVoters: "Non-Électeurs",
            },
            exportAllAreas: "Exporter les résultats de toutes les zones au format {{format}} pour '{{item}}'",
        },
        publish: {
            preview: {
                publicationAreas: "Sélectionnez la zone pour l'aperçu",
                action: "Aperçu",
                copy: "Copier le lien",
                copy_success: "Copie réussie du lien d'aperçu",
                copy_error: "Échec de la copie du lien d'aperçu",
                success: "Succès lors de l'ouverture de l'aperçu",
            },
            header: {
                change: "Changements à Publier",
                viewChange: "Voir Publication",
                history: "Historique des Changements",
            },
            action: {
                generateInitializationReport: "Générer le Rapport d'Initialisation",
                startVotingPeriod: "Commencer la période de vote",
                startKioskVoting: "Commencer Vote au Kiosque",
                startOnlineVoting: "Commencer Vote en Ligne",
                startEarlyVoting: "Commencer Vote Anticipé",
                startTelephoneVoting: "Commencer Vote Téléphone",
                stopVotingPeriod: "Arrêter la période de vote",
                stopOnlineVoting: "Arrêter le Vote en Ligne",
                stopEarlyVoting: "Arrêter le Vote Anticipé",
                stopTelephoneVoting: "Arrêter le Vote Téléphone",
                stopKioskVotingPeriod: "Arrêter le Vote au Kiosque",
                pauseVotingPeriod: "Mettre en pause la période de vote",
                pauseKioskVoting: "Mettre en pause le Vote au Kiosque",
                pauseOnlineVoting: "Mettre en pause le Vote en Ligne",
                pauseEarlyVoting: "Mettre en pause le Vote Anticipé",
                pauseTelephoneVoting: "Mettre en pause le Vote Téléphone",
                generate: "régénérer",
                publish: "Publier Changements",
                back: "Arrière",
            },
            empty: {
                header: "Aucune Publication pour l'instant.",
                action: "Générer Publication",
            },
            forbidden: {
                header: "Impossible de publier tant que la cérémonie des clés n'est pas terminée.",
            },
            dialog: {
                title: "Confirmer Action",
                info: "Vous avez cliqué sur une action sensible, nous avons donc besoin que vous la confirmiez pour pouvoir continuer.",
                initializationInfo: "Vous êtes sur le point de générer le rapport d'initialisation. Êtes-vous sûr de vouloir continuer?",
                startInfo: "Vous êtes sur le point de commencer la période de vote. Êtes-vous sûr de vouloir continuer?",
                stopInfo: "Vous êtes sur le point d'arrêter la période de vote. Êtes-vous sûr de vouloir continuer?",
                kioskStopInfo: "Vous êtes sur le point d'arrêter la période de vote au kiosque. Êtes-vous sûr de vouloir continuer ?",
                pauseInfo: "Vous êtes sur le point de mettre en pause la période de vote. Êtes-vous sûr de vouloir continuer?",
                publishInfo: "Vous êtes sur le point de générer une publication. Êtes-vous sûr de vouloir continuer ?",
                ok: "Confirmer",
                ko: "Annuler",
                error: "Erreur lors du chargement des bulletins publiés",
                error_publish: "Erreur lors de la publication du bulletin",
                error_capacity: "Échec de la génération du style de bulletin : {{message}}",
                error_status: "Erreur lors du changement d'état de la publication",
                error_preview: "Erreur lors de l'aperçu de la publication",
                diff: "Afficher tous les changements pourrait rendre la page non réactive. Êtes-vous sûr de vouloir continuer ?",
                confirmation: "L'action que vous êtes sur le point d'effectuer est sensible et nécessite une confirmation. Veuillez entrer votre mot de passe pour continuer avec {{action}}.",
            },
            label: {
                current: "Actuel",
                previous: "Publication Précédente",
                diff: "Changements à publier",
                publication: "Publication",
            },
            notifications: {
                generated: "Bulletin généré",
                published: "Bulletin publié",
                change_status: "État de votation changé",
            },
        },
        emailEditor: {
            subject: "Sujet de l'Email",
            tabs: {
                plaintext: "Corps de Texte Plano",
                richtext: "Corps de Texte Enrichi",
            },
        },
        sendCommunication: {
            send: "Envoyer",
            title: "Envoyer Notification",
            subtitle: "Envoyer une notification aux utilisateurs/électeurs.",
            sendButton: "Envoyer Notification",
            voters: "Audience",
            schedule: "Calendrier",
            nowInput: "Envoyer maintenant",
            dateInput: "Date et heure de début d'envoi",
            chooseDate: "Veuillez choisir une date",
            languages: "Langues",
            smsMessage: "Message SMS",
            errorSending: "Erreur lors de l'envoi de la notification : {{error}}",
            successSending: "Notification programmée/envoyée avec succès",
            method: "Méthode de Modèles",
            type: "Type de Communication",
            alias: "Alias de la Modèle",
            votersSelection: {
                ALL_USERS: "Tous",
                NOT_VOTED: "Ceux qui n'ont pas voté",
                VOTED: "Ceux qui ont déjà voté",
                SELECTED: "À {{total}} {{voters}} sélectionnés",
            },
            path: {
                users: "utilisateurs",
                voters: "électeurs",
            },
            methodTitle: "Méthode de Communication",
            communicationMethod: {
                EMAIL: "Email",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Identifiants",
                BALLOT_RECEIPT: "Reçu de Vote",
            },
            email: {
                subject: "Sujet",
            },
        },
        tallysheet: {
            title: "Urnes",
            subtitle: "Urnes numérisées par canal",
            createTallySuccess: "Feuille de Comptage créée",
            createTallyError: "Erreur lors de la création de la Feuille de Comptage",
            createTallyErrorSameKindExists: "La feuille de décompte existe déjà pour ce scrutin avec le même canal et la même zone",
            allFieldsRequired: "Tous les champs sont obligatoires",
            header: {
                change: "Changements à Publier",
                viewChange: "Voir Publication",
                history: "Historique de Publication",
            },
            action: {
                start: "Commencer Élection",
                stop: "Arrêter Élection",
                pause: "Pause",
                generate: "Régénérer",
                publish: "Publier Changements",
                back: "Arrière",
            },
            inputError: {
                totalValidDoesNotMatch: "Les votes des candidats ({{candidateVotesSum}}) doivent être compris entre {{lowerBound}} et {{upperBound}} selon les règles de vote de ce scrutin ({{nonBlankValidVotes}} votes valides non blancs × jusqu'à {{maxMarks}} marques par bulletin)",
                censusTooSmall: "Le total des votes ({{totalVotes}}) ne doit pas être supérieur au recensement ({{census}})",
                totalInvalidDoesNotMatch: "Le total des votes invalides ({{totalInvalid}}) doit être égal aux votes invalides implicites ({{implicitInvalid}}) plus les votes invalides explicites ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "Le total des votes ({{totalVotes}}) doit être égal au total des votes valides ({{totalValidVotes}}) plus le total des votes invalides ({{totalInvalid}})",
                unknownCountingAlgorithm: "L'algorithme de dépouillement de ce scrutin ({{countingAlgorithm}}) n'est pas reconnu, le nombre autorisé de votes de candidats ne peut donc pas être déterminé. Vérifiez la configuration du scrutin.",
                blankBallotsInconsistent: "Les Bulletins Blancs doivent avoir la même valeur sur toutes les feuilles de dépouillement de cette urne",
                blankBallotsOutOfBounds: "La valeur des Bulletins Blancs est en dehors de la plage impliquée par les décomptes de votes blancs par scrutin de cette urne",
            },
            label: {
                area: "Zone",
                channel: "Canal",
                total_votes: "Votes Totales",
                total_valid_votes: "Votes Válidos Totales",
                total_invalid: "Votes Inválidos Totales",
                explicit_invalid: "Votes Explícitement Inválidos",
                implicit_invalid: "Votes Implicitement Inválidos",
                total_blank_votes: "Votes en Blanc Totales",
                blank_ballots: "Bulletins Blancs",
                census: "Recensement",
            },
            common: {
                tallyCeremony: {
                    manage: "Gérer la Cérémonie de Décompte",
                    view: "Voir la Cérémonie de Décompte",
                    cancel: "Annuler la Cérémonie de Décompte",
                    addKey: "Ajouter une Clé de Décompte",
                },
                edit: "Éditer",
                confirm: "Confirmer",
                back: "Arrière",
                next: "Suivant",
                cancel: "Arrière",
                data: "Données",
                title: "Feuille de Comptage",
                subtitle: "Configuration de la Feuille de Comptage.",
                candidates: "Candidats",
                save: "Sauvegarder",
                approve: "Approuver",
                disapprove: "Désapprouver",
                show: "Afficher",
                add: "Ajouter",
                versions: "Versions",
                warningDisapprove: "Êtes-vous sûr de vouloir désapprouver cette Feuille de Décompte?",
                warningApprove: "Êtes-vous sûr de vouloir approuver cette Feuille de Décompte?",
            },
            empty: {
                header: "Aucune Feuille de Comptage.",
                action: "Générer Feuille de Comptage",
                add: "Ajouter",
            },
            breadcrumbSteps: {
                start: "Début",
                edit: "Éditer",
                confirm: "Confirmer",
                view: "Voir",
            },
            table: {
                area: "Zone",
                contest: "Scrutin",
                approvedVersion: "Version approuvée",
                latestVersion: "Dernière version",
                labels: "Étiquettes",
                annotations: "Annotations",
            },
            versionsTable: {
                title: "Versions de l'urne",
                version: "Version",
                createdBy: "Créé par",
                reviewedBy: "Révisé par",
                createdAt: "Créé le",
                reviewedAt: "Révisé le",
                sourceImport: "Import source",
                importStatus: "Statut de l'import",
                openImport: "Ouvrir l'import",
                sourceFile: "Fichier source",
            },
            message: {
                reviewError: "Erreur lors de la révision de la Feuille de Comptage",
                reviewSuccess: "Feuille de Comptage révisée",
            },
        },
        application: {
            import: {
                title: "Importer des Applications",
                subtitle: "Importer des données d'applications",
                paragraph: "Importez des applications en utilisant une feuille de calcul au format Valeurs Séparées par Comma (CSV). Téléchargez un exemple de fichier d'importation CSV ici.",
                messages: {
                    success: "Applications importées avec succès",
                    error: "Erreur lors de l'importation des applications",
                },
            },
            export: {
                title: "Exporter des Applications",
                subtitle: "Exporter des données d'applications",
                button: "Exporter",
                paragraph: "Exportez des applications en utilisant une feuille de calcul au format Valeurs Séparées par Comma (CSV).",
                messages: {
                    success: "Applications exportées avec succès",
                    error: "Erreur lors de l'exportation des applications",
                },
            },
        },
        template: {
            noPermissions: "Vous n'avez pas la permission d'accéder aux Modèles.",
            title: "Modèles",
            subtitle: "Liste des modèles",
            chooseMethods: "Choisir les méthodes",
            default: "Utiliser le modèle par défaut",
            empty: {
                title: "Aucun modèle",
                subtitle: "Voulez-vous créer un nouveau ?",
            },
            action: {
                createOne: "Créer Modèle",
            },
            create: {
                title: "Créer un Modèle",
                success: "Modèle créé",
                error: "Erreur lors de la création du modèle",
            },
            update: {
                success: "Modèle mis à jour",
                error: "Erreur lors de la mise à jour du modèle",
            },
            edit: {
                title: "Éditer un Modèle",
            },
            form: {
                smsMessage: "Message SMS",
                document: "Document",
                pdfOptions: "Options PDF",
                reportOptions: "Options de Rapport",
                name: "Nom du Modèle",
                alias: "Alias du Modèle",
                type: "Type",
                communicationMethod: "Méthode",
            },
            type: {
                CREDENTIALS: "Identifiants",
                INITIALIZATION_REPORT: "Rapport d'Initialisation",
                ELECTORAL_RESULTS: "Résultats Électoraux",
                BALLOT_IMAGES: "Images des Bulletins",
                BALLOT_RECEIPT: "Reçu de Vote",
                ACTIVITY_LOGS: "Journaux d'Activité",
                MANUAL_VERIFICATION: "Vérification Manuelle",
                PARTICIPATION_REPORT: "Rapport de Participation",
            },
            method: {
                email: "Email",
                sms: "SMS",
                document: "Document",
            },
            import: {
                title: "Importer des Modèles",
                subtitle: "Importer des données de modèles",
                paragraph: "Importez des modèles en utilisant une feuille de calcul au format Valeurs Séparées par Comma (CSV). Téléchargez un exemple de fichier d'importation CSV ici.",
            },
        },
        materials: {
            createMaterialSuccess: "Matériel de support créé",
            createMaterialError: "Erreur lors de la création du matériel de support",
            updateMaterialSuccess: "Matériel de support mis à jour",
            updateMaterialError: "Erreur lors de la mise à jour du matériel de support",
            common: {
                title: "Matériaux de Support",
                subtitle: "Entrer données du matériel de support.",
            },
            error: {
                title: "Le titre est obligatoire",
                document: "Le document est obligatoire",
            },
            fields: {
                isHidden: "Caché",
                publicUrl: "Lien public",
            },
            empty: {
                header: "Pas encore de matériel de support",
                action: "Générer du matériel de support",
            },
        },
        widget: {
            logs: "Journaux",
        },
        settings: {
            countries: {
                title: "Blocage des Pays",
                votingDescription: "Choisissez ci-dessous les pays depuis lesquels vous souhaitez bloquer les votes.",
                enrollmentDescription: "Choisissez ci-dessous les pays depuis lesquels vous souhaitez bloquer les inscriptions.",
                error: {
                    errorSaving: "Erreur lors de l'enregistrement de la liste des pays",
                },
            },
            backupRestore: {
                title: "Sauvegarde / Restauration de la configuration du locataire",
                backup: {
                    label: "Sauvegarde",
                    subtitle: "Sauvegarde des configurations du locataire",
                },
                restore: {
                    label: "Restaurer",
                    subtitle: "Restaurer la configuration du locataire",
                    title: "Importer les configurations du locataire",
                    paragraph: "Importer les configurations du locataire, les configurations Keycloak, les rôles et les données de permissions à l'aide d'un dossier compressé.",
                    tenantConfigOption: "Importer les configurations du locataire",
                    keycloakConfigOption: "Importer les configurations Keycloak",
                    RolesConfigOption: "Importer les configurations des rôles et des permissions",
                },
            },
            previewScreen: {
                label: "Aperçus",
                noContent: "Aucun aperçu trouvé",
                table: {
                    title: "Aperçus externes",
                    description: "Un registre des aperçus de styles de bulletins de vote générés via des requêtes externes",
                    requestedBy: "Demandé par",
                    document: "Document",
                    url: "URL",
                },
            },
            languages: {
                default: "Langue par défaut",
            },
        },
        approvalsScreen: {
            column: {
                status: "Statut",
                id: "ID",
                applicantId: "ID du Demandeur",
                verificationType: "Type de Vérification",
                createdAt: "Créé Le",
                updatedAt: "Mis à Jour Le",
                verified_by: "Vérifié Par",
            },
            approvalRequest: "Informations d'approbation",
            title: "Électeurs",
            subtitle: "Rechercher des électeurs correspondants",
            approve: {
                body: "Êtes-vous sûr de vouloir approuver cet électeur ? Cette action est irréversible.",
            },
            reject: {
                label: "Rejeter la demande",
                confirm: "Êtes-vous sûr de vouloir rejeter cet électeur ? Cette action est irréversible.",
                message: "Écrivez ici la raison du rejet",
                rejectReason: "Raison du rejet",
                messageRequired: "Un message de rejet est requis pour l'option 'Autre'",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Données Manquantes",
                    "no-matching-voter": "Électeur Non Correspondant",
                    "voter-already-approved": "Déjà Approuvé",
                    "other": "Autre",
                },
            },
            notifications: {
                approveError: "Erreur lors de l'approbation de l'électeur",
                approveSuccess: "Électeur approuvé",
                rejectError: "Erreur lors du rejet de l'électeur",
                rejectSuccess: "Électeur rejeté",
                VoterApprovedAlready: "L'électeur est déjà approuvé.",
            },
            export: {
                success: "L'exportation des applications a été réalisée avec succès",
                error: "Erreur lors de l'exportation des applications",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Électeurs",
                enrolledOverseasVoters: "Électeurs Inscrits à l'Étranger",
                approvalStatus: "Statut d'Approbation: Électeurs Approuvés/Désapprouvés",
                manuallyApproval: "Électeurs Approuvés/Désapprouvés Manuellement",
                automaticallyApproval: "Électeurs Approuvés/Désapprouvés Automatiquement",
                authenticatedVoters: "Électeurs Authentifiés",
                invalidUserErrors: "Erreurs d'Utilisateur Invalide:",
                invalidPasswordErrors: "Erreurs de Mot de Passe Invalide:",
            },
            polls: {
                title: "Sondages",
                initializedSystems: "Publications avec Systèmes Initialisés",
                votingOpened: "Publications avec Votations Ouvertes",
                votingClosed: "Publications avec Votations Closes",
                votingStarted: "Publications avec Votations Commencées",
                voterTurnout: "Taux de Participation des Électeurs",
            },
            tally: {
                title: "Comptage",
                activeVotesCounting: "Publications avec Comptage des Votes Actif",
                generatedERs: "Publications avec ERs Générés",
                transmittedResults: "Publications avec Résultats Transmis",
            },
            testing: {
                title: "Tests",
                testElectionVoterCount: "Comptage des Votants lors de l'Élection de Test",
            },
        },
        certificateAuthorities: {
            title: "Certificats",
            subtitle: "Autorités de certification (CA) de confiance pour cet événement électoral. Les CA importées sont utilisées pour valider les certificats des électeurs.",
            importButton: "Importer des certificats",
            type: {
                root: "Racine",
                intermediate: "Intermédiaire",
            },
            expiry: {
                expired: "Expiré",
                expiringSoon: "Expire bientôt",
                valid: "Valide",
            },
            columns: {
                commonName: "Nom commun",
                type: "Type",
                issuerCn: "CN de l'émetteur",
                notBefore: "Valide à partir de",
                notAfter: "Expire le",
                fingerprint: "Empreinte SHA256",
            },
            importDialog: {
                title: "Importer des autorités de certification",
                subtitle: "Importer un ou plusieurs certificats CA depuis un fichier PEM",
                description: "Sélectionnez un fichier PEM contenant un ou plusieurs certificats. Les paquets sont pris en charge — chaque certificat est importé individuellement.",
                selectFile: "Sélectionner un fichier PEM",
                fileLoaded: "Fichier chargé ({{bytes}} octets)",
                importButton: "Importer",
            },
            notify: {
                importSuccess: "{{inserted}} certificat(s) importé(s).",
                importSkipped: "{{count}} ignoré(s) (déjà présent(s)).",
                importErrors: "Problèmes d'importation : {{errors}}",
                importError: "Échec de l'importation : {{error}}",
                deleteSuccess: "Certificat supprimé.",
                deleteError: "Erreur lors de la suppression du certificat.",
                exportSuccess: "Certificat(s) exporté(s) avec succès.",
                exportError: "Erreur lors de l'exportation des certificats.",
            },
            exportDialog: {
                title: "Exporter les autorités de certification",
                description: "Vous êtes sur le point d'exporter {{amount}} certificat(s).",
                all: "tous",
            },
            deleteDialog: {
                description: "Êtes-vous sûr de vouloir supprimer {{count}} certificat(s) ?",
            },
            emptyHeader: "Aucune autorité de certification n'a été importée pour cet événement électoral.",
            fileReadError: "Échec de la lecture du fichier.",
            viewDialog: {
                title: "Détails de l'autorité de certification",
                subject: "Sujet",
                issuer: "Émetteur",
                serialNumber: "Numéro de série",
                pemContent: "Contenu PEM",
            },
            confirmDelete: "Supprimer l'autorité de certification",
            confirmDeleteDescription: 'Êtes-vous sûr de vouloir supprimer le certificat "{{name}}" (empreinte : {{fingerprint}}) ?',
        },
    },
};
export default frenchTranslation;
